(function () {
    'use strict';

    const root = document.querySelector('[data-genplan]');
    if (!root) return;

    // Боковая панель менеджера уходит, пока схема под ней: она липкая и ложилась поверх
    // правого края генплана, закрывая корпуса (слово владельца 22.09.2026: «заходит на
    // генплан, а не исчезает»).
    // ⛔ ПО ПЕРЕСЕЧЕНИЮ С САМОЙ ПАНЕЛЬЮ, А НЕ ПО «СРЕДНЕЙ ПОЛОВИНЕ ОКНА» (проверка
    // 26.09.2026, P2-1). Прежний наблюдатель с полями −25 % прятал панель, лишь когда
    // блок доходил до середины экрана: первые ~120 px прокрутки схема уже лежала под
    // панелью и резала кнопку телефона (пересечение до 53 тыс. px² на 1440), и так же на
    // уходе схемы вверх. Теперь панель скрыта ровно тогда, когда рамки блока и панели
    // пересекаются, — и видна, пока схема лишь выглядывает снизу под краем панели.
    // Скрыта она через `visibility` (css/jk-genplan.css), место занимает — замер честен.
    // ⛔ СТОИТ ДО ВСЕХ РАННИХ ВЫХОДОВ НИЖЕ: у схемы без обводки (одна картинка, «Тёплые края»)
    // и у полного вида без панели корпуса скрипт выходит раньше, и прежде панель лежала
    // поверх такой схемы постоянно (проверка 26.09.2026, «вне блока»).
    (function hideRailOverGenplan() {
        const layout = root.closest('.jk-page-layout');
        const rail = layout ? layout.querySelector('.jk-rail') : null;
        if (!layout || !rail) return;
        let queued = 0;
        const check = () => {
            queued = 0;
            const plan = root.getBoundingClientRect();
            const side = rail.getBoundingClientRect();
            // В пределах ОКНА: колонка бывает выше окна (низ за краем экрана), и без
            // этого она уходила бы, когда схема ещё ниже экрана и не видна вовсе.
            const over = plan.height > 0 && side.height > 0 && side.width > 0
                && Math.max(plan.top, side.top, 0) < Math.min(plan.bottom, side.bottom, window.innerHeight)
                && plan.left < side.right && plan.right > side.left;
            layout.classList.toggle('genplan-vo-vsyu-shirinu', over);
        };
        const schedule = () => {
            if (!queued) queued = requestAnimationFrame(check);
        };
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        if (typeof ResizeObserver === 'function') new ResizeObserver(schedule).observe(root);
        schedule();
    })();
    // Компактный вид — витрина квартир ЖК и страница комнатности (24.09.2026, слово
    // владельца: генплан «поменьше, чтобы было легко искать квартиры»), а с 26.09.2026 и
    // карточка ЖК («пусть генплан на странице ЖК будет так же, как на странице
    // комнатности»). Клик по корпусу СУЖАЕТ список на этой же странице событием
    // `broni:genplan-corpus` (его слушают js/flats.js на витрине и js/jk-filter.js на
    // карточке и странице группы); повторный клик по тому же корпусу отбор снимает.
    const compact = root.hasAttribute('data-genplan-compact');
    const clickBehavior = ['none', 'all_flats'].includes(root.dataset.genplanClickBehavior)
        ? root.dataset.genplanClickBehavior : 'section';
    const clickNote = root.dataset.genplanClickNote || '';
    // Широкая полоса схемы — только на компьютере; на телефоне (≤900) схема целиком.
    const wideScreen = compact && window.matchMedia ? window.matchMedia('(min-width: 901px)') : null;
    // ⛔ Карточка ЖК на компьютере (≥1025) — схема во всю ширину страницы и во всю свою
    // высоту, без обрезки полосой (слово владельца 27.09.2026: «ген план должен быть на
    // всю страницу как раньше»). Полоса остаётся витрине и комнатности; телефон — как был.
    const cardFullWide = compact && root.closest('.jk-page-layout:not(.jk-page-layout--rooms)') && window.matchMedia
        ? window.matchMedia('(min-width: 1025px)') : null;

    const shapeBoxes = new WeakMap();
    function shapeBox(shape) {
        const cached = shapeBoxes.get(shape);
        if (cached) return cached;
        let box = null;
        try { box = shape.getBBox(); } catch { box = null; }
        if (!box || !(box.width > 0 || box.height > 0)) return null;
        const plain = { x: box.x, y: box.y, width: box.width, height: box.height };
        shapeBoxes.set(shape, plain);
        return plain;
    }

    // Только витрина квартир: картинка и обводки в одном окне SVG, во всю ширину.
    // Кадр ставим по рамке всех контуров; слишком высокая рамка сохраняет прежние поля.
    function cropShowcaseScene(svg) {
        if (!compact || !root.closest('.page-hero--flats') || !wideScreen || !wideScreen.matches || !svg || svg.hasAttribute('data-parent-scene')) return false;
        const full = svg.dataset.fullViewBox || svg.getAttribute('viewBox') || '';
        svg.dataset.fullViewBox = full;
        const [X, Y, W, H] = full.split(/\s+/).map(Number);
        const rect = svg.getBoundingClientRect();
        if (!(W > 0) || !(H > 0) || !rect.width || !rect.height) return false;
        const height = W * rect.height / rect.width;
        let top = Infinity, bottom = -Infinity;
        let left = Infinity, right = -Infinity;
        svg.querySelectorAll('[data-genplan-building], [data-genplan-group]').forEach(shape => {
            const box = shapeBox(shape);
            if (!box) return;
            top = Math.min(top, box.y); bottom = Math.max(bottom, box.y + box.height);
            left = Math.min(left, box.x); right = Math.max(right, box.x + box.width);
        });
        if (height > H || bottom - top > height || left < X || right > X + W || top < Y || bottom > Y + H) return false;
        const center = Number.isFinite(top) ? (top + bottom) / 2 : Y + H / 2;
        const y = Math.max(Y, Math.min(center - height / 2, Y + H - height));
        svg.setAttribute('viewBox', [X, y, W, height].join(' '));
        return true;
    }

    const select = root.querySelector('[data-genplan-select]');
    const polygons = Array.from(root.querySelectorAll('[data-genplan-building]'));
    const scenes = new Map(Array.from(root.querySelectorAll('[data-genplan-scene]')).map(scene => [scene.dataset.genplanScene, scene]));
    const navigation = root.querySelector('[data-genplan-navigation]');
    const sceneName = root.querySelector('[data-genplan-scene-name]');
    const back = root.querySelector('[data-genplan-back]');
    const backLabel = root.querySelector('[data-genplan-back-label]');
    const notice = root.querySelector('[data-genplan-image-error]');
    // ⛔ 16.10.2026: сервер отдаёт узел ПУСТЫМ — надпись «Схема временно недоступна…»
    // лежала в HTML каждой карточки ЖК, и Яндекс брал её в сниппет. Текст ставится
    // только в момент показа и снимается при скрытии; вторая фраза — если у схемы
    // есть список корпусов (шаблон ставит data-genplan-error-list).
    const showNotice = on => {
        if (!notice) return;
        notice.textContent = on
            ? 'Схема временно недоступна.' + (notice.hasAttribute('data-genplan-error-list') ? ' Выберите корпус в списке.' : '')
            : '';
        notice.hidden = !on;
    };
    const caption = root.querySelector('[data-genplan-map-caption]');
    const discountLegend = root.querySelector('[data-genplan-discount-legend]');
    const empty = root.querySelector('[data-genplan-empty]');
    const details = root.querySelector('[data-genplan-details]');
    const link = root.querySelector('[data-genplan-link]');
    const unavailable = root.querySelector('[data-genplan-no-flats]');
    // Карточка корпуса на телефоне: срок со этажностью и строки комнатности.
    const chips = root.querySelector('[data-genplan-chips]');
    const roomList = root.querySelector('[data-genplan-rooms]');

    // ── Картинка схемы: готовые файлы по ширинам, оригинал — по требованию ──────
    // Слова владельца 23.09.2026: «генпланы только оригинал фото» · «чтобы не глючило —
    // только страница» · «на телефоне можно по весу уменьшить, как делают грамотно».
    // Шаблон кладёт в `data-srcset` копии (1200, 2000) и оригинал; `href` в разметке
    // нет — у <image> в SVG нет loading="lazy", а оригинал весит до 12 МБ.
    // Порядок: блок подошёл к экрану → лёгкая копия (превью) → нужная ширина, каждая
    // подменяется только ПОСЛЕ полной загрузки и расшифровки, поэтому без мигания;
    // размер держит viewBox, поэтому без сдвига вёрстки. Пальцами увеличили → оригинал.
    // ⛔ Не ниже 2000 точек: 1200 мылили подписи корпусов — ровно на это жаловался владелец.
    const SCHEME_MIN_WIDTH = 2000;
    const visibleScene = () => root.querySelector('[data-genplan-scene]:not([hidden])');
    let schemeNear = typeof IntersectionObserver !== 'function';

    function schemeCandidates(image) {
        return (image.dataset.srcset || '').split(',').map(part => {
            const [url, width] = part.trim().split(/\s+/);
            return { url, w: parseInt(width, 10) || 0 };
        }).filter(item => item.url && item.w > 0).sort((a, b) => a.w - b.w);
    }

    function schemeDecoded(url) {
        return new Promise((resolve, reject) => {
            const probe = new Image();
            probe.decoding = 'async';
            if ('fetchPriority' in probe) probe.fetchPriority = 'low';
            probe.onload = () => (probe.decode ? probe.decode() : Promise.resolve()).then(resolve, resolve);
            probe.onerror = reject;
            probe.src = url;
        });
    }

    function schemeShow(image, item) {
        if ((Number(image.dataset.shownWidth) || 0) >= item.w) return;
        image.setAttribute('href', item.url);
        image.dataset.shownWidth = String(item.w);
    }

    // ⛔ РАЗМЫТЫХ ПОЛЕЙ ПО БОКАМ БОЛЬШЕ НЕТ (слово владельца 25.09.2026: «можно пошире
    // генплан, без замазывания»). Прежде при плотной схеме окно не резалось до полной
    // ширины, и поля слева и справа заливались той же схемой, размытой и притемнённой.
    // Окно схемы повторяет пропорции полосы (cropScene); если все корпуса в него не
    // влезают, по бокам ровные поля цвета фона рамки — не размытая схема.

    function loadScheme(scene, wantOriginal) {
        const image = scene && scene.querySelector('[data-genplan-image]');
        if (!image || !schemeNear) return;
        const list = schemeCandidates(image);
        if (!list.length) return;
        const canvas = image.closest('svg');
        const box = canvas ? canvas.getBoundingClientRect().width : 0;
        // Компактный генплан свёрнут (телефон до нажатия «Показать») — не грузим ничего:
        // схему человек ещё не просил, и её байты не нужны странице.
        if (compact && !box) return;
        const need = Math.max(box * (window.devicePixelRatio || 1), SCHEME_MIN_WIDTH);
        // Увеличение пальцами — НАСТОЯЩИЙ оригинал из data-original (не пересжатая
        // .full.webp): ширина +1, чтобы он встал поверх показанной копии той же ширины.
        const original = image.dataset.original
            ? { url: image.dataset.original, w: list[list.length - 1].w + 1 }
            : list[list.length - 1];
        // ⛔ КОМПАКТНЫЙ ВИД — ТОЛЬКО ГОТОВАЯ УМЕНЬШЕННАЯ КОПИЯ (доводка r3, 25.09.2026,
        // проверка Б P1-1). Полоса стоит на ПЕРВОМ экране витрины и комнатности, и
        // «ширина полосы × плотность» без потолка тянула оригинал или .w2000: у ДОГМА ПАРК
        // 203 КБ + 842 КБ, у схем ФСК на плотности 2 — до 7,7 МБ. Берём самую лёгкую
        // готовую копию (.w1200.webp; нет её — то, что меньше), оригинал — только при
        // увеличении пальцами. Карточка ЖК (полный вид) выбирает по-прежнему.
        // Карточка ЖК на компьютере во всю ширину — выбор по ширине, как у прежнего полного вида.
        const strip = compact && !(cardFullWide && cardFullWide.matches);
        const target = wantOriginal ? original
            : (strip ? list[0] : (list.find(item => item.w >= need) || list[list.length - 1]));
        if ((Number(image.dataset.shownWidth) || 0) >= target.w || (Number(image.dataset.pendingWidth) || 0) >= target.w) return;
        // ⛔ КОМПАКТНАЯ ПОЛОСА — ОДНА ЗАГРУЗКА (проверка 25.09.2026, P2-1). Проба через
        // new Image() и затем тот же адрес в <image> схемы давали на проде ДВА скачивания
        // одного файла; у схем без лёгкой копии (A101) это оригинал дважды — студии
        // Бунинских 2 891 КБ против 1 438 КБ. Здесь выбор один (лёгкая копия, нет её —
        // оригинал), поэтому адрес ставится сразу, без пробы: мигать нечему — до него
        // в полосе пусто. Карточка ЖК (полный вид) и увеличение пальцами — как прежде.
        if (strip && !wantOriginal) {
            schemeShow(image, target);
            return;
        }
        image.dataset.pendingWidth = String(target.w);
        if (!image.dataset.shownWidth && list[0].w < target.w) {
            schemeDecoded(list[0].url).then(() => schemeShow(image, list[0]), () => {});
        }
        schemeDecoded(target.url).then(() => schemeShow(image, target), () => {
            // Ничего не показано — отдаём адрес самой схеме: её событие error
            // включит штатное «Схема временно недоступна».
            if (!image.dataset.shownWidth) image.setAttribute('href', target.url);
        });
    }

    if (!schemeNear) {
        const near = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            near.disconnect();
            schemeNear = true;
            loadScheme(visibleScene(), false);
        }, { rootMargin: '800px 0px' });
        near.observe(root);
    }
    // Увеличение пальцами на телефоне — догружаем оригинал видимой схемы.
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', () => {
            if (window.visualViewport.scale > 1.1) loadScheme(visibleScene(), true);
        });
    }

    // Static plans still need a visible failure state when their local image fails.
    if (!select) {
        scenes.forEach(scene => {
            const image = scene.querySelector('[data-genplan-image]');
            if (image) image.addEventListener('error', () => {
                scene.setAttribute('hidden', '');
                showNotice(true);
            });
        });
        const refreshStatic = () => scenes.forEach(scene => {
            if (scene.hasAttribute('hidden')) return;
            if (!cropShowcaseScene(scene) && scene.dataset.fullViewBox) scene.setAttribute('viewBox', scene.dataset.fullViewBox);
        });
        refreshStatic();
        window.addEventListener('resize', refreshStatic);
        if (typeof ResizeObserver === 'function') new ResizeObserver(refreshStatic).observe(root);
        loadScheme(visibleScene(), false);
        return;
    }
    // Карточка корпуса есть только в полном виде; у компактного вместо неё строка
    // состояния и кнопка «Все корпуса».
    if (!compact && (!empty || !details || !link || !unavailable)) return;

    const options = new Map(Array.from(select.options).filter(option => option.value).map(option => [option.value, option]));
    const name = root.querySelector('[data-genplan-name]');
    const count = root.querySelector('[data-genplan-count]');
    const countSource = root.querySelector('[data-genplan-count-source]');
    const price = root.querySelector('[data-genplan-price]');
    if (!compact && (!name || !count || !countSource || !price)) return;
    const status = root.querySelector('[data-genplan-status]');
    const resetAll = root.querySelector('[data-genplan-reset]');

    // ── Строка корпуса: ОДНА сборка на подсказку большой области и на список корпусов
    // приближенной сцены (27.09.2026). Числа — из тех же <option>, второго источника нет.
    const corpLabel = option => option.dataset.label || 'Корпус ' + option.dataset.name;
    const corpOnSale = option => parseInt(option.dataset.countLabel || '', 10) > 0;
    function corpsWord(k) {
        const mod10 = k % 10;
        const mod100 = k % 100;
        return mod10 === 1 && mod100 !== 11 ? 'корпус'
            : (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14) ? 'корпуса' : 'корпусов');
    }
    function roomsShort(option) {
        let rooms = [];
        try { rooms = JSON.parse(option.dataset.roomTypes || '[]'); } catch { rooms = []; }
        if (!Array.isArray(rooms)) return '';
        const labels = rooms.map(room => {
            const n = Number(room && room.rooms);
            if (n === 0) return 'студии';
            return Number.isFinite(n) && n > 0 ? (n >= 4 ? '4+' : String(n)) + '-комн.' : '';
        }).filter(Boolean);
        return labels.filter((label, index) => labels.indexOf(label) === index).join(', ');
    }
    function addSpan(parent, className, text) {
        if (!text) return;
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        parent.appendChild(span);
    }
    // Название и цена от — строкой; ниже срок сдачи · квартиры в продаже · комнатности.
    function fillCorpRow(row, option, prefix) {
        const head = document.createElement('span');
        head.className = prefix + '-head';
        addSpan(head, prefix + '-name', corpLabel(option));
        addSpan(head, prefix + '-price', option.dataset.priceLabel);
        row.appendChild(head);
        addSpan(row, prefix + '-facts', [
            window.BuildStatus.deadlineLine(option.dataset.deadline),
            option.dataset.countLabel || '', roomsShort(option),
        ].filter(Boolean).join(' · '));
    }

    // Адрес «Квартиры корпуса» печатает сервер (BuildingGenplanPresentation::flatsUrl):
    // `?sections=…&section_numbers=…`. Из него же берём отбор для списка на странице —
    // вторая выборка корпуса разошлась бы с картой и с карточкой ЖК.
    const localFlatsUrl = url => typeof url === 'string' && /^\/(?![/\\])[^\s\\]*$/.test(url);
    function corpusFilter(option) {
        const url = option ? option.dataset.flatsUrl || '' : '';
        if (!localFlatsUrl(url)) return { section: '', sectionNumbers: '' };
        const query = new URLSearchParams(url.split('?')[1] || '');
        return { section: query.get('sections') || '', sectionNumbers: query.get('section_numbers') || '' };
    }

    // Строка состояния компактного вида: появляется ТОЛЬКО после выбора — текст
    // в разметке при загрузке не лежит (робот Яндекса исполняет JS и забирает текст).
    // ⛔ Без чисел корпуса: они про весь дом, а на странице комнатности список ниже —
    // про одну комнатность, и «51 квартира» над «2 квартирами» читалась бы как ошибка.
    // Сколько квартир отобрано, говорит сам список («Найдено N», «N планировок»).
    function showStatus(option) {
        if (resetAll) resetAll.hidden = clickBehavior !== 'section' || !option || !resultsTarget();
        if (!status) return;
        status.hidden = !option;
        if (!option) { status.textContent = ''; return; }
        const label = option.dataset.label || 'Корпус ' + option.dataset.name;
        if (clickBehavior !== 'section') {
            status.textContent = label + ': ' + clickNote;
        } else if (!corpusFilter(option).section) {
            status.textContent = label + ': ' + (option.dataset.noFlatsNote || 'квартир этого корпуса пока нет в нашей подборке');
        } else if (resultsTarget()) {
            status.textContent = 'Показаны квартиры: ' + label;
        } else {
            // Страница квартиры: списка, который можно сузить, нет — говорим про корпус.
            // Числа корпусов она не печатает вовсе (отпечаток страницы, доводка r3), и
            // пустые части в строку не идут — «Корпус 3 · undefined» не бывает.
            status.textContent = [label, option.dataset.countLabel, option.dataset.priceLabel]
                .filter(part => typeof part === 'string' && part !== '').join(' · ');
        }
    }

    // Список, который сужает выбор корпуса (витрина — строка «Найдено N», комнатность —
    // сетка планировок). На странице квартиры его нет: там генплан только показывает.
    function resultsTarget() {
        try {
            return root.dataset.genplanResults ? document.querySelector(root.dataset.genplanResults) : null;
        } catch {
            return null;
        }
    }

    // Плавный переход к узлу страницы. Шапка сайта (#mainHeader, fixed) уезжает вверх,
    // когда страницу листают ВНИЗ дальше 240 px (js/shared.js), и возвращается при
    // движении ВВЕРХ — поэтому место под неё оставляем только когда она будет видна.
    // «Меньше движения» в системе — переход мгновенный: 'instant', а не 'auto', потому
    // что у html стоит scroll-behavior: smooth, и 'auto' его наследует.
    // ⛔ ЛИПКАЯ ПАНЕЛЬ КАРТОЧКИ ЖК (#jkStickyBar, `.jk-sticky-nav.visible`) — ТОЖЕ ШАПКА
    // (проверка 26.09.2026, P2-2). Она видна на всей карточке ниже первого экрана и при
    // прокрутке ВНИЗ не уезжает (jk.js, слово владельца 21.09.2026), а генплан карточки
    // стоит НИЖЕ планировок: «Посмотреть на генплане» вела к нему вниз, и «Вернуться к
    // планировке» с заголовком «Генплан комплекса» уходили под панель на ~10 px (1024–1440).
    // Обе стоят у верхнего края окна, поэтому закрыто столько, сколько выше из видимых.
    function stickyBarHeight() {
        const bar = document.querySelector('.jk-sticky-nav.visible:not(.scroll-hidden)');
        return bar ? bar.offsetHeight : 0;
    }
    function topCover(down) {
        const header = document.getElementById('mainHeader');
        const headerHeight = header && !down ? header.offsetHeight : 0;
        return Math.max(headerHeight, stickyBarHeight());
    }
    function scrollToNode(target) {
        if (!target) return;
        const from = window.scrollY;
        let top = target.getBoundingClientRect().top + from - 12;
        top -= topCover(top > from && top > 240);
        const reduced = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: reduced ? 'instant' : 'smooth' });
    }

    // ── Широкая невысокая полоса (слово владельца 25.09.2026: «генплан на всю ширину,
    // но не большой по вертикали», «можно пошире генплан, без замазывания»). На
    // компьютере высоту схемы задаёт CSS, а окно схемы (viewBox) вырезается по корпусам:
    // пустое небо и лес по краям уходят, контуры и картинка в одних координатах.
    //
    // ⛔ КОРПУСА НЕ ТЕРЯЕМ НИ ОДНОГО (проверка 25.09.2026, P1-2). Прежнее окно всегда
    // держало пропорции полосы во всю ширину схемы и вставало по середине корпусов: у
    // схем, где дома стоят и сверху, и снизу, из полосы выпадали и те, и другие — на 1920
    // 65 корпусов из 949 в 12 схемах, «Гранель Живописный» без единого дома в кадре.
    // Теперь опорная область — РАМКИ всех контуров целиком плюс поле:
    //   1. сначала окно во всю ширину схемы в пропорциях полосы (полей нет вовсе);
    //   2. корпуса в него не влезают — окно растёт ровно настолько, чтобы влезли, и по
    //      бокам встают РОВНЫЕ поля цвета фона рамки. Никакого размытия и затемнения.
    // Окно встаёт по середине корпусов и держит их рамку внутри целиком. На телефоне
    // (≤900) — схема целиком.
    // ⛔ РАМКА КОНТУРА КОРПУСА — ОДИН ЗАМЕР НА ВСЮ ЖИЗНЬ СТРАНИЦЫ (проверка 25.09.2026, P1-3).
    // Геометрия контуров неизменна (точки из разметки), а каждый getBBox() после любой
    // записи в документ — это пересчёт раскладки ВСЕЙ страницы. На студиях Самолёта-6
    // (60 тысяч узлов) 66 чередований «вставка подписи → замер контура» стоили 3,9 с
    // главного потока на телефоне. Пустая рамка (схема ещё свёрнута и не отрисована) —
    // не кэшируется: замерим, когда схему покажут.
    function cropScene(svg) {
        if (!compact || !svg) return;
        if (cropShowcaseScene(svg)) return;
        const full = svg.dataset.fullViewBox || svg.getAttribute('viewBox') || '';
        svg.dataset.fullViewBox = full;
        const [, , W, H] = full.split(/\s+/).map(Number);
        // Приближенная сцена БОЛЬШОЙ ОБЛАСТИ (не обзор комплекса) — у неё свои правила ниже.
        const groupScene = svg.hasAttribute('data-parent-scene');
        const rect = svg.getBoundingClientRect();
        const wide = Boolean(wideScreen && wideScreen.matches);
        // ⛔ СПИСОК КОРПУСОВ СЦЕНЫ ЛЕЖИТ ПОВЕРХ ПРАВОГО КРАЯ СХЕМЫ (компьютер, 27.09.2026):
        // схема не становится уже договорённого, а корпуса уходят в часть окна ЛЕВЕЕ списка —
        // под полупрозрачной панелью остаётся только фон. Доля — ширина списка к ширине схемы.
        // Место оставляется и до того, как список построен (страница квартиры), — без скачка.
        const inset = wide && rect.width > 0 && listEligible(svg)
            ? Math.min(0.45, areaListWidth(rect.width) / rect.width) : 0;
        if (!wide || (cardFullWide && cardFullWide.matches && !inset)
            || !rect.width || !rect.height || !(W > 0) || !(H > 0)) {
            if (svg.getAttribute('viewBox') !== full) svg.setAttribute('viewBox', full);
            return;
        }
        // Поле вокруг корпусов — 1,5 % большей стороны схемы. Полоса витрины и
        // комнатности фиксирована CSS; все корпуса вписываются в её окно SVG.
        // ⛔ Сцена области — корпуса ЦЕЛИКОМ и с запасом 3 % (слово владельца 27.09.2026:
        // «корпуса обрезаются краями»): крышу не срезаем.
        const strip = !(cardFullWide && cardFullWide.matches);
        const roof = groupScene || strip ? 0 : 0.08;
        let x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        svg.querySelectorAll('[data-genplan-building], [data-genplan-group]').forEach(shape => {
            const box = shapeBox(shape);
            if (!box) return;
            x0 = Math.min(x0, box.x); x1 = Math.max(x1, box.x + box.width);
            y0 = Math.min(y0, box.y + box.height * roof); y1 = Math.max(y1, box.y + box.height);
        });
        if (!Number.isFinite(x0)) { x0 = 0; y0 = 0; x1 = W; y1 = H; }
        const pad = Math.max(W, H) * (groupScene ? 0.03 : 0.015);
        x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad);
        x1 = Math.min(W, x1 + pad); y1 = Math.min(H, y1 + pad);
        const ratio = rect.width / rect.height;
        // 1. Самое большое окно в пропорциях полосы, не выходящее за схему.
        let vh = Math.min(H, W / ratio);
        let vw = vh * ratio;
        // Уменьшенная полоса: окно растёт до всех корпусов, высота блока остаётся
        // прежней. У высокого исходника по бокам виден фон рамки, контуры не режутся.
        if ((groupScene || strip) && y1 - y0 > vh) { vh = y1 - y0; vw = vh * ratio; }
        if ((groupScene || strip) && x1 - x0 > vw) { vw = x1 - x0; vh = vw / ratio; }
        // Корпуса целиком левее списка: не влезают — окно растёт (поля цвета рамки).
        if (inset && x1 - x0 > vw * (1 - inset)) { vw = (x1 - x0) / (1 - inset); vh = vw / ratio; }
        // 2. Карточка ЖК: окно НЕ растёт полями (слово владельца 27.09.2026: «продлить ген план по
        //    верхнее меню, чтоб затемнения не было… высоту не нужно, только ширину»):
        //    схема всегда заполняет полосу во всю ширину, высота полосы прежняя; не
        //    влезшее по высоте срезается сверху/снизу по середине корпусов. Раньше окно
        //    росло, и по бокам стояли тёмные поля цвета фона (Инстеп: вид -206…2766 из 2560).
        // Окно по середине корпусов; внутри схемы, если помещается; иначе поля поровну.
        // Рамка корпусов остаётся внутри окна в любом случае.
        const place = (lo, hi, size, total) => {
            let start = size <= total
                ? Math.max(0, Math.min((lo + hi) / 2 - size / 2, total - size))
                : (total - size) / 2;
            start = Math.min(start, lo);
            return Math.max(start, hi - size);
        };
        // Со списком: корпуса по середине ЛЕВОЙ, открытой части окна; окно — внутри схемы,
        // если помещается, а не влезшее уходит вправо, под список.
        const placeLeft = () => {
            const open = vw * (1 - inset);
            let start = (x0 + x1) / 2 - open / 2;
            start = Math.max(Math.min(start, W - vw), Math.min(0, W - vw));
            return Math.min(x0, Math.max(x1 - open, start));
        };
        const vx = inset ? placeLeft() : place(x0, x1, vw, W);
        const vy = place(y0, y1, vh, H);
        const next = [vx, vy, vw, vh].map(value => Math.round(value * 10) / 10).join(' ');
        if (svg.getAttribute('viewBox') !== next) svg.setAttribute('viewBox', next);
    }

    // Кнопки корпусов рядом со схемой — выбрать корпус одним нажатием, не целясь в
    // контур на маленькой схеме. При длинном списке (десятки корпусов) остаётся только
    // список выбора — стена кнопок искать не помогает.
    // ⛔ КНОПКИ ПЕЧАТАЕТ СЕРВЕР (26.09.2026, BuildingGenplanPresentation::corpsButtons):
    // у схемы, открытой на телефоне с первого кадра, замена списка выбора кнопками
    // после загрузки сдвигала бы всё ниже на глазах. Здесь на готовые кнопки вешается
    // только нажатие; собрать их из <option> — запасной путь для разметки без них.
    // Число — пара BuildingGenplanPresentation::CORPS_BUTTONS_MAX, равенство стережёт тест.
    const CORPS_BUTTONS_MAX = 24;
    const serverCorps = compact ? root.querySelector('[data-genplan-corps]') : null;
    const corpsBox = serverCorps || (compact && options.size > 0 && options.size <= CORPS_BUTTONS_MAX
        ? document.createElement('div') : null);
    const corpsButtons = new Map();
    if (serverCorps) {
        serverCorps.querySelectorAll('[data-genplan-corp]').forEach(button => {
            const id = button.dataset.genplanCorp;
            if (!options.has(id) || corpsButtons.has(id)) return;
            button.addEventListener('click', () => pick(id, true));
            corpsButtons.set(id, button);
        });
    } else if (corpsBox) {
        corpsBox.className = 'jk-genplan-corps';
        corpsBox.setAttribute('role', 'group');
        corpsBox.setAttribute('aria-label', 'Корпуса');
        options.forEach((option, id) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'jk-genplan-corp' + (clickBehavior !== 'section' || corpusFilter(option).section ? '' : ' is-empty')
                + (Number(option.dataset.discountCount) > 0 ? ' has-discount' : '');
            button.textContent = option.dataset.label || 'Корпус ' + option.dataset.name;
            button.setAttribute('aria-pressed', 'false');
            button.addEventListener('click', () => pick(id, true));
            corpsButtons.set(id, button);
            // Пробел между кнопками — как в серверной разметке: без него текст ряда
            // читался бы «Позиция 3Корпус» (проверка 26.09.2026, P2-1).
            corpsBox.append(' ', button);
        });
        select.insertAdjacentElement('afterend', corpsBox);
    }
    if (corpsBox) {
        // Кнопки заменяют список выбора: два одинаковых выбора рядом только путают.
        // Список остаётся в разметке — в нём живёт выбранное значение.
        select.hidden = true;
        const selectLabel = root.querySelector('.jk-genplan-select-label');
        if (selectLabel) selectLabel.hidden = true;
    }

    // Подсказку области (corpusTip ниже) убирает любая смена сцены: её контур ушёл с экрана.
    let hideGroupTip = () => {};

    // ═══ СПИСОК КОРПУСОВ ПРИБЛИЖЕННОЙ СЦЕНЫ И ПУТЬ ПО УРОВНЯМ (27.09.2026) ═══
    // Слово владельца: «чтобы человек на генплане мог видеть, где находится корпус». У каждой
    // сцены своя картинка застройщика (другая «камера»), поэтому контур корпуса на общий вид
    // не переносится — вместо этого рядом с приближенной сценой список её корпусов:
    //  • наведение / фокус на строку — корпус загорается золотом НА СХЕМЕ, остальные приглушены;
    //  • наведение на корпус на схеме — выделяется его строка (список прокручивается сам,
    //    страница — нет);
    //  • нажатие на строку — то же, что нажатие на корпус. На сенсорном экране наведения нет:
    //    первое касание зажигает корпус и подкручивает экран к схеме, второе — выбирает.
    // Компьютер (≥ 901) — панель поверх правого края схемы, корпуса уходят левее (cropScene);
    // телефон — список под схемой.
    // ⛔ СПИСОК И ПУТЬ ПОЯВЛЯЮТСЯ ТОЛЬКО ПОСЛЕ ДЕЙСТВИЯ ЧЕЛОВЕКА. Робот Яндекса исполняет наш JS
    // и берёт видимый текст в сниппет (1 456 страниц однажды). Страница квартиры открывает
    // сцену своего корпуса сама, при загрузке, — там список и путь ждут первого касания,
    // наведения или клавиши; до них — прежняя одна подпись сцены.
    let interacted = false;
    let areaList = null;
    let previewId = '';
    let armedRow = '';
    const canHover = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
    function areaListWidth(width) {
        return width >= 1100 ? 320 : 280;
    }
    function listEligible(scene) {
        return compact && Boolean(scene) && scene.dataset.genplanScene !== 'master'
            && Array.from(scene.querySelectorAll('[data-genplan-building]')).some(shape => options.has(shape.dataset.genplanBuilding));
    }
    const sceneSvg = scene => (scene && scene.tagName.toLowerCase() === 'svg' ? scene : scene?.querySelector('svg')) || null;

    // Путь «Весь комплекс › Очередь › Квартал» — каждый уровень выше текущего кликабелен.
    function renderPath(scene) {
        const actualId = scene.dataset.genplanScene;
        const parentId = scene.dataset.parentScene || 'master';
        if (backLabel) backLabel.textContent = interacted || parentId !== 'master' ? 'Назад' : 'Весь комплекс';
        if (!sceneName) return;
        if (actualId === 'master' || !interacted) {
            sceneName.textContent = actualId === 'master' ? '' : scene.dataset.sceneName;
            return;
        }
        const chain = [scene];
        let parent = scene.dataset.parentScene || 'master';
        while (chain.length < 12) {
            const next = scenes.get(parent);
            if (!next || chain.includes(next)) break;
            chain.unshift(next);
            if (parent === 'master') break;
            parent = next.dataset.parentScene || 'master';
        }
        const parts = [];
        chain.forEach((item, index) => {
            const itemId = item.dataset.genplanScene;
            const text = itemId === 'master' ? 'Весь комплекс' : item.dataset.sceneName || 'Часть комплекса';
            if (index === chain.length - 1) {
                const current = document.createElement('span');
                current.className = 'jk-genplan-crumb-current';
                current.setAttribute('aria-current', 'location');
                current.textContent = text;
                parts.push(current);
                return;
            }
            const crumb = document.createElement('button');
            crumb.type = 'button';
            crumb.className = 'jk-genplan-crumb';
            crumb.dataset.genplanCrumb = itemId;
            crumb.textContent = text;
            const separator = document.createElement('span');
            separator.className = 'jk-genplan-crumb-sep';
            separator.setAttribute('aria-hidden', 'true');
            separator.textContent = '›';
            parts.push(crumb, separator);
        });
        sceneName.replaceChildren(...parts);
    }

    function areaRows() {
        return areaList ? Array.from(areaList.querySelectorAll('[data-genplan-area-row]')) : [];
    }
    // Строка корпуса в видимой части списка. Прокручивается САМ СПИСОК (scrollTop), а не
    // страница: scrollIntoView увёл бы и окно.
    function hotRow(id, reveal) {
        areaRows().forEach(row => {
            const on = Boolean(id) && row.dataset.genplanAreaRow === id;
            row.classList.toggle('is-hot', on);
            if (!on || !reveal || !areaList || areaList.scrollHeight <= areaList.clientHeight) return;
            const top = row.offsetTop - areaList.offsetTop;
            if (top < areaList.scrollTop) areaList.scrollTop = top;
            else if (top + row.offsetHeight > areaList.scrollTop + areaList.clientHeight) {
                areaList.scrollTop = top + row.offsetHeight - areaList.clientHeight;
            }
        });
    }
    // Корпус горит на схеме: золото, прочие приглушены, его подпись — первой в раскладке.
    function setPreview(id) {
        if (previewId === id) return;
        previewId = id;
        root.classList.toggle('has-preview', Boolean(id));
        polygons.forEach(shape => shape.classList.toggle('is-preview', Boolean(id) && shape.dataset.genplanBuilding === id));
        root.querySelectorAll('[data-genplan-label]').forEach(label => {
            label.classList.toggle('is-preview', Boolean(id) && label.dataset.genplanLabel === id);
        });
        hotRow(id, false);
        const svg = sceneSvg(visibleScene());
        const state = svg ? labelLayouts.get(svg) : null;
        if (state) {
            state.hovered = id;
            layoutLabels(svg);
        }
    }
    function syncAreaRows() {
        areaRows().forEach(row => {
            const on = Boolean(select.value) && row.dataset.genplanAreaRow === select.value;
            row.classList.toggle('active', on);
            row.setAttribute('aria-pressed', String(on));
        });
    }
    // Касание строки на телефоне: схема над списком — подводим её в кадр.
    function revealPlan() {
        const svg = sceneSvg(visibleScene());
        if (!svg) return;
        const rect = svg.getBoundingClientRect();
        if (rect.top >= topCover(false) && rect.bottom <= window.innerHeight) return;
        scrollToNode(navigation && !navigation.hidden ? navigation : svg);
    }
    function onRowClick(id, event) {
        interacted = true;
        const touch = !(canHover && canHover.matches) && event.detail !== 0;
        if (touch && armedRow !== id) {
            armedRow = id;
            previewId = '';
            setPreview(id);
            revealPlan();
            return;
        }
        armedRow = '';
        setPreview('');
        if (compact) pick(id, true);
    }
    function removeAreaList() {
        if (areaList) areaList.remove();
        areaList = null;
        armedRow = '';
    }
    function buildAreaList(scene) {
        removeAreaList();
        const map = root.querySelector('.jk-genplan-map');
        if (!map) return;
        const ids = [];
        scene.querySelectorAll('[data-genplan-building]').forEach(shape => {
            const id = shape.dataset.genplanBuilding;
            if (options.has(id) && !ids.includes(id)) ids.push(id);
        });
        if (!ids.length) return;
        // Порядок — как у подсказки области: корпуса в продаже первыми, дальше как в списке.
        const order = Array.from(options.keys());
        ids.sort((a, b) => Number(corpOnSale(options.get(b))) - Number(corpOnSale(options.get(a))) || order.indexOf(a) - order.indexOf(b));
        const box = document.createElement('div');
        box.className = 'jk-genplan-arealist';
        box.dataset.genplanAreaList = scene.dataset.genplanScene;
        box.setAttribute('role', 'group');
        box.setAttribute('aria-label', 'Корпуса: ' + (scene.dataset.sceneName || 'часть комплекса'));
        const title = document.createElement('p');
        title.className = 'jk-genplan-arealist__title';
        title.textContent = ids.length + ' ' + corpsWord(ids.length) + ' на схеме';
        const list = document.createElement('ul');
        list.className = 'jk-genplan-arealist__list';
        ids.forEach(id => {
            const option = options.get(id);
            const row = document.createElement('button');
            row.type = 'button';
            row.className = 'jk-genplan-arealist__row' + (clickBehavior !== 'section' || corpOnSale(option) ? '' : ' is-empty');
            row.dataset.genplanAreaRow = id;
            row.setAttribute('aria-pressed', 'false');
            fillCorpRow(row, option, 'jk-genplan-arealist__row');
            row.addEventListener('mouseenter', () => setPreview(id));
            row.addEventListener('mouseleave', () => { if (armedRow !== id) setPreview(''); });
            row.addEventListener('focus', () => setPreview(id));
            row.addEventListener('blur', () => { if (armedRow !== id) setPreview(''); });
            row.addEventListener('click', event => onRowClick(id, event));
            const item = document.createElement('li');
            item.appendChild(row);
            list.appendChild(item);
        });
        box.append(title, list);
        map.appendChild(box);
        areaList = box;
        syncAreaRows();
    }
    // Компьютер: панель по высоте и месту схемы; телефон — в потоке под схемой (CSS).
    function placeAreaList() {
        if (!areaList) return;
        const svg = sceneSvg(visibleScene());
        const wide = Boolean(wideScreen && wideScreen.matches) && svg;
        areaList.classList.toggle('is-overlay', Boolean(wide));
        if (!wide) {
            ['top', 'height', 'width'].forEach(key => areaList.style.removeProperty(key));
            return;
        }
        // ⛔ У <svg> нет offsetTop/offsetHeight (только у HTML-узлов) — место берём из рамок.
        const box = svg.getBoundingClientRect();
        const map = areaList.offsetParent || areaList.parentElement;
        const mapTop = map ? map.getBoundingClientRect().top + (map.clientTop || 0) : box.top;
        areaList.style.top = Math.round(box.top - mapTop) + 'px';
        areaList.style.height = Math.round(box.height) + 'px';
        areaList.style.width = areaListWidth(box.width) + 'px';
    }
    // Первое действие человека (касание, клавиша, наведение на генплан): сцена, открытая
    // страницей сама (страница квартиры), получает путь и список.
    function markInteracted() {
        if (interacted) return;
        interacted = true;
        const scene = visibleScene();
        if (!scene || !select) return;
        renderPath(scene);
        if (!areaList && listEligible(scene)) {
            buildAreaList(scene);
            placeAreaList();
        }
    }
    if (compact) {
        ['pointerdown', 'keydown', 'touchstart'].forEach(type => document.addEventListener(type, markInteracted, { capture: true, passive: true }));
        root.addEventListener('pointerover', markInteracted, { passive: true });
        root.addEventListener('focusin', markInteracted);
        // Корпус на схеме под мышью / в фокусе — его строка в списке.
        polygons.forEach(shape => {
            const id = shape.dataset.genplanBuilding;
            shape.addEventListener('mouseenter', () => hotRow(id, true));
            shape.addEventListener('focus', () => hotRow(id, true));
            shape.addEventListener('mouseleave', () => hotRow(previewId, false));
            shape.addEventListener('blur', () => hotRow(previewId, false));
        });
        if (sceneName) sceneName.addEventListener('click', event => {
            const crumb = event.target.closest && event.target.closest('[data-genplan-crumb]');
            if (crumb) goUp(crumb.dataset.genplanCrumb);
        });
    }

    function showScene(id) {
        const scene = scenes.get(id) || scenes.get('master');
        if (!scene) return;
        hideGroupTip();
        setPreview('');
        const actualId = scene.dataset.genplanScene;
        const parentId = scene.dataset.parentScene || 'master';
        scenes.forEach(canvas => canvas.toggleAttribute('hidden', canvas !== scene || canvas.dataset.failed === 'true'));
        root.dataset.genplanActiveScene = actualId;
        if (navigation) navigation.hidden = actualId === 'master';
        if (back) back.setAttribute('aria-label', 'Вернуться: ' + (scenes.get(parentId)?.dataset.sceneName || 'Весь комплекс'));
        renderPath(scene);
        showNotice(scene.dataset.failed === 'true');
        if (caption) caption.textContent = scene.querySelector('[data-genplan-group]')
            ? 'Выберите часть комплекса'
            : (clickBehavior === 'none' ? 'Схема расположения домов'
                : (clickBehavior === 'all_flats' ? 'Нажмите на корпус — все квартиры ЖК'
                    : (compact && resultsTarget() ? 'Нажмите на корпус — покажем его квартиры' : 'Корпуса доступны для выбора')));
        if (discountLegend) discountLegend.hidden = !scene.querySelector('[data-genplan-building].has-discount');
        cropScene(scene);
        loadScheme(scene, false);
        drawLabels(scene);
        if (areaList && areaList.dataset.genplanAreaList !== actualId) removeAreaList();
        if (interacted && !areaList && listEligible(scene)) buildAreaList(scene);
        placeAreaList();
    }

    // На телефоне схема шире экрана и листается вбок: выбранный в списке корпус
    // иначе остаётся за кадром. Подводим его к центру видимой части.
    function revealActive(id) {
        const polygon = polygons.find(item => item.dataset.genplanBuilding === id);
        if (!polygon) return;
        const box = polygon.closest('.jk-genplan-map');
        if (!box || box.scrollWidth <= box.clientWidth) return;
        const svg = polygon.ownerSVGElement;
        if (!svg) return;
        const bounds = polygon.getBBox();
        const scale = svg.getBoundingClientRect().width / (svg.viewBox.baseVal.width || 1);
        const centre = (bounds.x + bounds.width / 2) * scale - box.clientWidth / 2;
        const target = Math.max(0, Math.min(centre, box.scrollWidth - box.clientWidth));
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        box.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }

    function choose(id) {
        const option = options.get(id);
        // Сцена уже на экране — не перерисовываем её заново (окно, картинка, подписи):
        // это лишние пересчёты раскладки страницы на каждом выборе корпуса (P1-3).
        const sceneId = option ? option.dataset.sceneId || 'master' : '';
        if (option && sceneId !== root.dataset.genplanActiveScene) showScene(sceneId);
        select.value = option ? id : '';
        polygons.forEach(polygon => {
            const active = Boolean(option) && polygon.dataset.genplanBuilding === id;
            polygon.classList.toggle('active', active);
            polygon.setAttribute('aria-pressed', String(active));
        });
        // Затемнение остальной схемы: золото на светлом рендере не читается,
        // тёмная подложка под выбранным корпусом — единственный надёжный способ (замер 21.09.2026).
        root.classList.toggle('has-selection', Boolean(option));
        root.querySelectorAll('[data-genplan-label]').forEach(label => {
            label.classList.toggle('active', Boolean(option) && label.dataset.genplanLabel === id);
        });
        scenes.forEach(scene => {
            const svg = scene.tagName.toLowerCase() === 'svg' ? scene : scene.querySelector('svg');
            if (svg) layoutLabels(svg);
        });
        // ⛔ Только полный вид (телефон карточки, схема 640 px листается вбок). Компактная
        // полоса вбок не листается никогда: размытые поля (scale 1.08) давали ей
        // «переполнение» в 63 px, и программная прокрутка резала подписи и «← Весь
        // комплекс» (доводка r3, проверка А P1-2). Рамка там ещё и `overflow: clip`.
        if (option && !compact) revealActive(id);
        scenes.forEach(scene => {
            const controls = Array.from(scene.querySelectorAll('[data-genplan-building], [data-genplan-group]'));
            const selected = controls.find(control => control.dataset.genplanBuilding === id);
            controls.forEach((control, index) => control.setAttribute('tabindex', selected ? (control === selected ? '0' : '-1') : (index === 0 ? '0' : '-1')));
        });
        if (compact) {
            syncAreaRows();
            corpsButtons.forEach((button, buttonId) => {
                const on = Boolean(option) && buttonId === id;
                button.classList.toggle('active', on);
                button.setAttribute('aria-pressed', String(on));
            });
            showStatus(option);
            return;
        }
        empty.hidden = Boolean(option);
        details.hidden = !option;
        if (!option) return;

        name.textContent = option.dataset.label || 'Корпус ' + option.dataset.name;
        count.textContent = option.dataset.countLabel;
        countSource.textContent = option.dataset.countSource;
        price.textContent = option.dataset.priceLabel;
        const discount = root.querySelector('[data-genplan-discount]');
        if (discount) {
            discount.textContent = option.dataset.discountLabel || '';
            discount.hidden = !option.dataset.discountLabel;
        }

        // Links are built server-side from our corpus filter. Never follow an API URL.
        const url = option.dataset.flatsUrl || '';
        const hasFlats = url.startsWith('/') && !url.startsWith('//');
        link.hidden = !hasFlats;
        unavailable.hidden = hasFlats;
        unavailable.textContent = option.dataset.noFlatsNote || 'В нашей подборке пока нет квартир этого корпуса.';
        if (hasFlats) link.setAttribute('href', url);
        else link.removeAttribute('href');
        if (clickBehavior !== 'section') {
            unavailable.textContent = clickNote;
            if (hasFlats) link.textContent = 'Все квартиры ЖК →';
        }

        // ⛔ На телефоне наведения нет, и подсказка не появляется вовсе: там корпус
        // выбирают в списке, а сведения читают в этой карточке. Без этих строк
        // комнатность, площади и этажность были видны только на большом экране
        // (замер 22.09.2026, City Bay на 390 px).
        if (chips) {
            const marks = [window.BuildStatus.deadlineLine(option.dataset.deadline), option.dataset.floorsLabel || ''];
            chips.replaceChildren();
            marks.filter(Boolean).forEach(text => {
                const span = document.createElement('span');
                span.className = 'jk-genplan-chip';
                span.textContent = text;
                chips.appendChild(span);
            });
            chips.hidden = !chips.childElementCount;
        }
        if (roomList) {
            roomList.replaceChildren();
            let rooms = [];
            try { rooms = JSON.parse(option.dataset.roomTypes || '[]'); } catch { /* Нет данных — нет строк. */ }
            if (hasFlats && Array.isArray(rooms)) rooms.forEach(room => {
                if (!room || typeof room.flats_url !== 'string' || !room.flats_url.startsWith('/')
                    || room.flats_url.startsWith('//') || typeof room.label !== 'string'
                    || typeof room.area_label !== 'string' || typeof room.price_label !== 'string') return;
                const item = document.createElement('li');
                const row = document.createElement('a');
                row.className = 'jk-genplan-room';
                row.dataset.rooms = String(room.rooms);
                row.href = roomRowHref(room, option);
                [[room.label, 'jk-genplan-room__name'], [room.area_label, 'jk-genplan-room__area'],
                    [room.price_label, 'jk-genplan-room__price']].forEach(([text, className]) => {
                    const span = document.createElement('span');
                    span.className = className;
                    span.textContent = text;
                    row.appendChild(span);
                });
                row.setAttribute('aria-label', room.label + ', ' + room.area_label + ', ' + room.price_label + ' — ' + name.textContent);
                item.appendChild(row);
                roomList.appendChild(item);
            });
            roomList.hidden = !roomList.childElementCount;
        }
    }

    // Компактный вид: сообщаем странице, какой корпус выбран, — список ниже сузится.
    // Корпус не наш (квартир в подборке нет) — отбор снимается, а строка состояния
    // честно говорит, что квартир этого корпуса у нас пока нет.
    // Событие СИНХРОННОЕ: слушатель списка может вернуть в `detail.matched`, сколько
    // квартир корпуса в нём есть (страница комнатности знает это сразу), и
    // в `detail.roomsLabel` — чего именно нет («студий», «1-комн. квартир»).
    function announce(id, rooms) {
        const option = options.get(id);
        let roomTypes = [];
        try { roomTypes = JSON.parse(option?.dataset.roomTypes || '[]'); } catch { roomTypes = []; }
        const detail = {
            id: id || '', label: option ? option.dataset.label || '' : '', ...corpusFilter(option),
            roomTypes: Array.isArray(roomTypes) ? roomTypes.map(room => Number(room && room.rooms)).filter(Number.isFinite) : [],
            matched: undefined, roomsLabel: '',
        };
        if (typeof rooms === 'number') detail.rooms = rooms;
        if (!id) filtered = null;
        document.dispatchEvent(new CustomEvent('broni:genplan-corpus', { detail }));
        return detail;
    }

    // Слово владельца 25.09.2026: «при клике на генплан он должен переходить на квартиры,
    // которые там есть». После выбора корпуса страница ПЛАВНО уходит к списку (витрина —
    // строка «Найдено N квартир», комнатность — сетка планировок); как — scrollToNode().
    // 28.09.2026, слово владельца: «тыкаю на генплане на студию — открывался сразу блок
    // планировки и студии, а не верхнее меню начала фильтра». Блок квартир карточки ЖК и
    // страницы группы (#jkFlats) начинается шапкой «N квартир» и фильтром «Подобрать
    // квартиру» — переход встаёт НИЖЕ них, на полосу «Найдено · сортировка · вид», сразу
    // над карточками планировок. Витрина (`.flats-toolbar-section`) и есть такая полоса.
    function resultsLanding() {
        const target = resultsTarget();
        if (!target) return null;
        const bar = target.querySelector('.jk-filter__bar');
        return bar && bar.getClientRects().length ? bar : target;
    }
    function revealResults() {
        scrollToNode(resultsLanding());
    }

    // Корпус, подсвеченный кнопкой «На генплане» у квартиры: это «показать где», а не
    // отбор. Первый клик по такому корпусу на схеме — отбор, а не снятие подсветки.
    let locatedId = '';
    function clearLocated() {
        locatedId = '';
        polygons.forEach(polygon => polygon.classList.remove('is-located'));
    }

    // ── «Вернуться к квартире / к планировке» (слово владельца 25.09.2026: «кнопка
    // вернуться к квартире аккуратная, если с планировки переносится туда, чтобы с
    // генплана быстро обратно, не листая, перейти»). Переход к генплану запоминает, откуда
    // он: прокрутку, узел, получивший нажатие, и (у окна планировки) как открыть его
    // снова. Кнопка встаёт НАД схемой в потоке — корпуса и схему не закрывает, нижнюю
    // панель телефона тоже. Нажатие: прокрутка на место без анимации, состояние обратно
    // (окно открыто снова, раскрытая панель и так на месте), фокус — на исходную кнопку.
    // Уходит сама, если человек сам ушёл прокруткой от генплана или выбрал другой корпус.
    let backState = null;
    let backBar = null;
    let backWatch = null;
    function hideBack() {
        backState = null;
        if (backBar) backBar.hidden = true;
        if (backWatch) { backWatch.disconnect(); backWatch = null; }
    }
    // ⛔ ВОЗВРАТ — К ЭЛЕМЕНТУ, А НЕ К ЧИСЛУ ПРОКРУТКИ (проверка Б 25.09.2026, P1-1). Пока
    // человек смотрел генплан, выше выросли и схема (на телефоне переход раскрыл свёрнутую
    // плашку), и строка «Корпус … — здесь эта планировка», и сама кнопка возврата: прежнее
    // число прокрутки уводило исходную обложку на 409–671 px. Поэтому до перехода
    // запоминаем, где на ЭКРАНЕ стоял исходный узел, а при возврате ставим его туда же.
    // Схему, которую раскрыл сам переход, сворачиваем обратно.
    function snapshotFrom(from) {
        const top = from && from.isConnected ? from.getBoundingClientRect().top : null;
        return { y: window.scrollY, top, opened: Boolean(compactToggle) && !root.classList.contains('is-open') };
    }
    function goBack() {
        const state = backState;
        hideBack();
        if (!state) return;
        if (state.opened) setOpen(false);
        const target = state.from && state.from.isConnected ? state.from : null;
        const y = target && typeof state.top === 'number'
            ? window.scrollY + target.getBoundingClientRect().top - state.top
            : state.y;
        window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: 'instant' });
        if (typeof state.restore === 'function') state.restore();
        else if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }
    function showBack(label, from, restore, before) {
        if (!compact) return;
        const map = root.querySelector('.jk-genplan-map');
        if (!map) return;
        if (!backBar) {
            backBar = document.createElement('div');
            backBar.className = 'jk-genplan-back-bar';
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'jk-genplan-return';
            button.dataset.ym = 'genplan_return';
            const icon = document.createElement('i');
            icon.className = 'fa-solid fa-arrow-left';
            icon.setAttribute('aria-hidden', 'true');
            button.append(icon, document.createElement('span'));
            button.addEventListener('click', goBack);
            backBar.appendChild(button);
            map.parentNode.insertBefore(backBar, map);
        }
        const at = before || snapshotFrom(from);
        backState = { y: at.y, top: at.top, opened: at.opened, from: from || null, restore: typeof restore === 'function' ? restore : null };
        backBar.querySelector('span').textContent = label || 'Вернуться назад';
        backBar.hidden = false;
        // Ушёл прокруткой от генплана — кнопка больше не нужна. Сначала ждём, когда
        // генплан войдёт в кадр (наша же плавная прокрутка к нему), потом — когда выйдет.
        if (backWatch) backWatch.disconnect();
        if (typeof IntersectionObserver === 'function') {
            let seen = false;
            backWatch = new IntersectionObserver(entries => {
                const visible = entries.some(entry => entry.isIntersecting);
                if (visible) seen = true;
                else if (seen) hideBack();
            });
            backWatch.observe(root);
        }
    }

    // Отбор, который СЕЙЧАС действует на списке: корпус и строка состояния о нём.
    // Нужен кнопке «На генплане»: она подсвечивает дом квартиры, но отбор списка не
    // трогает — и строка о нём не должна пропадать (доводка r3, проверка А P2-2).
    let filtered = null;

    // Выбор корпуса в компактном виде. `toggle` — клик по схеме или кнопке корпуса:
    // повторный клик по уже выбранному корпусу снимает отбор, БЕЗ прокрутки (слово
    // владельца 24.09.2026). `rooms` — строка комнатности из подсказки («1-комнатные»):
    // корпус и комнатность выбираются вместе.
    function pick(id, toggle, rooms) {
        // План без подтверждённой разбивки квартир по корпусам не шлёт отбор:
        // none сохраняет выдачу; all_flats открывает чистый адрес всех квартир ЖК.
        if (clickBehavior !== 'section') {
            interacted = true;
            hideBack();
            clearLocated();
            choose(id);
            const url = options.get(id)?.dataset.flatsUrl || '';
            if (clickBehavior === 'all_flats' && localFlatsUrl(url)) window.location.assign(url);
            return;
        }
        const next = toggle && id && select.value === id && locatedId !== id ? '' : id;
        interacted = true;
        // Человек выбрал корпус сам — возврат «к квартире» больше не про это.
        hideBack();
        clearLocated();
        choose(next);
        const detail = announce(next, rooms);
        filtered = null;
        if (!next || !detail.section) return;
        const label = options.get(next)?.dataset.label || '';
        if (detail.matched === 0) {
            // Квартир этой комнатности в корпусе нет — страница стоит на месте.
            const what = detail.roomsLabel || root.dataset.genplanPageRoomsLabel || 'квартир';
            if (status) status.textContent = 'В этом корпусе нет ' + what;
            return;
        }
        if (status && typeof rooms === 'number') {
            status.textContent = 'Показаны ' + (rooms === 0 ? 'студии' : rooms + '-комн.') + ': ' + label;
        }
        filtered = { id: next, note: status ? status.textContent : '' };
        revealResults();
    }

    // ── Строки комнатности корпуса («Студии · от … м² · от … ₽») — в подсказке и в панели
    // под схемой (28.09.2026, слово владельца: «тыкаю на генплане на студию — открывался
    // сразу блок планировки и студии»). Куда ведут:
    //  · страница со списком (карточка ЖК, витрина, своя группа на странице группы) — отбор
    //    корпуса и комнатности НА МЕСТЕ и переход к планировкам (pick → revealResults);
    //  · страница группы, чужая комнатность — страница ЕЁ группы (адрес с этой же страницы, из
    //    полосы `.jkr-nav`, второго сборщика адресов нет — как в js/jk-filter.js) с якорем
    //    `#planirovki&sections=…`: та страница встаёт на планировки и выбирает этот корпус;
    //  · групповой страницы нет или списка нет (страница квартиры) — прежняя витрина корпуса
    //    с якорем `#planirovki`: витрина встаёт на «Найдено N квартир».
    const PLANS_ANCHOR = 'planirovki';
    const pageRoomsOwn = () => {
        const own = root.dataset.genplanPageRooms;
        return own !== undefined && own !== '' ? Number(own) : null;
    };
    function roomsPageHref(rooms) {
        const nav = document.querySelector('.jkr-nav');
        if (!nav || !Number.isInteger(rooms) || rooms < 0) return '';
        let found = '';
        nav.querySelectorAll('a[data-bucket]').forEach(link => {
            const bucket = Number(link.dataset.bucket);
            const min = link.dataset.roomsMin !== undefined ? Number(link.dataset.roomsMin) : null;
            if (found || !(bucket === rooms || (min !== null && rooms >= min))) return;
            found = (link.getAttribute('href') || '').split('#')[0];
        });
        return localFlatsUrl(found) ? found : '';
    }
    function sameRoomsAsPage(rooms) {
        const own = pageRoomsOwn();
        if (own === null) return true;
        return own >= 4 ? rooms >= 4 : rooms === own;
    }
    function roomRowHref(room, option) {
        const rooms = Number(room.rooms);
        if (compact && pageRoomsOwn() !== null && !sameRoomsAsPage(rooms)) {
            const page = roomsPageHref(rooms);
            if (page) {
                const filter = corpusFilter(option);
                const query = new URLSearchParams();
                if (filter.section) query.set('sections', filter.section);
                if (filter.sectionNumbers) query.set('section_numbers', filter.sectionNumbers);
                const extra = query.toString();
                return page + '#' + PLANS_ANCHOR + (extra ? '&' + extra : '');
            }
        }
        return String(room.flats_url).split('#')[0] + '#' + PLANS_ANCHOR;
    }
    // Нажатие на строку: отбор на месте, если он здесь возможен. `true` — нажатие обработано.
    function roomRowInPlace(event, row, id) {
        if (!compact || !row || !id || !options.has(id) || !resultsTarget()) return false;
        const rooms = Number(row.dataset.rooms);
        if (!Number.isFinite(rooms) || !sameRoomsAsPage(rooms)) return false;
        event.preventDefault();
        // Страница группы: комнатность прибита адресом — шлём только корпус.
        pick(id, false, pageRoomsOwn() !== null ? undefined : rooms);
        return true;
    }

    // ── Адрес страницы (доводка r3, проверка А P1-1). Витрина пишет отбор корпуса в
    // адрес (`?sections=…&section_numbers=…`, js/flats.js) и по нему же восстанавливает
    // выдачу — при заходе по ссылке «Квартиры корпуса» с карточки ЖК и по «Назад» /
    // «Вперёд». Генплан читает ТОТ ЖЕ адрес, иначе подпись и подсветка говорили бы
    // «Корпус 2» над выдачей всего комплекса. Корпус — тот, чья серверная ссылка несёт
    // ровно эти `sections` и `section_numbers`; несколько корпусов в адресе или чужое
    // имя — не выбран никакой (генплан молчит, а не врёт). Событие отбора НЕ шлётся:
    // выдачу по адресу восстанавливает сама витрина, второй загрузки не нужно.
    // Только витрина (`data-genplan-address`): страница комнатности адрес не пишет.
    const followsAddress = compact && root.hasAttribute('data-genplan-address');
    function corpusMatching(query) {
        const section = query.get('sections') || '';
        const numbers = query.get('section_numbers') || '';
        let found = '';
        if (section) options.forEach((option, id) => {
            const filter = corpusFilter(option);
            if (!found && filter.section === section && filter.sectionNumbers === numbers) found = id;
        });
        return found;
    }
    function corpusFromAddress() {
        return corpusMatching(new URLSearchParams(window.location.search));
    }
    // Страница группы, открытая строкой комнатности с генплана соседней группы:
    // `…/kvartiry/2-komnatnye/#planirovki&sections=…&section_numbers=…`. Корпус — в якоре,
    // а не в query: часть после `#` на сервер не уходит (у страницы группы нет адресов с
    // отбором корпуса ни для кэша, ни для робота), canonical и заголовки те же.
    function corpusFromPlansHash() {
        const hash = String(window.location.hash || '');
        if (!/^#planirovki&/.test(hash)) return '';
        return corpusMatching(new URLSearchParams(hash.slice('#planirovki&'.length)));
    }
    function syncFromAddress() {
        const id = corpusFromAddress();
        clearLocated();
        choose(id);
        filtered = id && status && !status.hidden ? { id, note: status.textContent } : null;
    }

    // ── «На генплане» у квартиры (слово владельца 25.09.2026: «чтобы на квартире была
    // кнопка "посмотреть на генплане", и она переносила на генплан — смотреть
    // расположение»). Нажатие: страница ПЛАВНО поднимается к генплану (без перезагрузки,
    // адрес не меняется), корпус квартиры подсвечен, у генплана подпись «Корпус N —
    // здесь эта квартира». Отбор списка НЕ меняется — это «показать где».
    // На телефоне свёрнутая плашка раскрывается.
    // 25.09.2026: планировка встречается в нескольких корпусах — подсвечены ВСЕ её
    // корпуса (`ids`), выбран первый; подпись «…— здесь эта планировка».
    let locatedIds = [];
    function locate(idOrIds, what) {
        const ids = (Array.isArray(idOrIds) ? idOrIds : [idOrIds]).filter(item => options.has(item));
        const id = ids[0];
        const option = options.get(id);
        if (!option) return false;
        interacted = true;
        if (compactToggle && !root.classList.contains('is-open')) setOpen(true);
        choose(id);
        locatedId = id;
        const labels = ids.map(item => options.get(item).dataset.label || 'Корпус ' + options.get(item).dataset.name);
        const label = labels.join(', ');
        // Отбор списка остаётся прежним — остаются и строка о нём, и кнопка его снять:
        // иначе «Найдено 18» стояло бы без единого видимого объяснения (проверка А P2-2).
        const listFiltered = Boolean(filtered && resultsTarget());
        if (status) {
            status.hidden = false;
            status.textContent = label + ' — здесь эта ' + (what || 'квартира') + (listFiltered && filtered.note ? '. ' + filtered.note : '');
        }
        if (resetAll) resetAll.hidden = !listFiltered;
        polygons.forEach(polygon => {
            const on = ids.includes(polygon.dataset.genplanBuilding);
            polygon.classList.toggle('is-located', on);
            if (on) polygon.classList.add('active');
        });
        root.querySelectorAll('[data-genplan-label]').forEach(text => {
            if (ids.includes(text.dataset.genplanLabel)) text.classList.add('active');
        });
        locatedIds = ids;
        return true;
    }

    // ⛔ НИЗКИЙ ЭКРАН (проверка устройств 25.09.2026, P2-2). Верх блока на экране — это ещё
    // не корпус: телефон боком (844×390) показывал шапку, плашку, «Вернуться» и лес, а
    // подсвеченный дом оставался ниже края. Если при верхе блока на месте низ подсвеченных
    // контуров за краем — листаем ровно настолько, чтобы они встали целиком (верх контуров
    // не уходит выше края). Экран, где всё помещается, ведёт себя как прежде.
    // Зовётся ПОСЛЕ showBack(): полоса «Вернуться» встаёт над схемой и сдвигает её на ~50 px —
    // замер до неё оставлял низ корпуса за краем ровно на высоту полосы.
    function scrollToLocated(ids) {
        let top = Infinity;
        let bottom = -Infinity;
        polygons.forEach(polygon => {
            if (!ids.includes(polygon.dataset.genplanBuilding)) return;
            const rect = polygon.getBoundingClientRect();
            if (rect.height > 0) { top = Math.min(top, rect.top); bottom = Math.max(bottom, rect.bottom); }
        });
        const header = document.getElementById('mainHeader');
        const headerHeight = header ? header.offsetHeight : 0;
        // Липкая панель карточки закрывает верх окна и здесь (P2-2 выше).
        const bar = stickyBarHeight();
        const rootTop = root.getBoundingClientRect().top;
        if (!(bottom > top) || bottom - rootTop + Math.max(headerHeight, bar) + 28 <= window.innerHeight) {
            scrollToNode(root);
            return;
        }
        const from = window.scrollY;
        let y = from + bottom + 16 - window.innerHeight;
        if (top - (y - from) < 12 + bar) y = from + top - 12 - bar;
        const reduced = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduced ? 'instant' : 'smooth' });
    }

    // Корпус квартиры по её секции — тем же ключом, что у отбора (серверная ссылка
    // корпуса). Секция встречается у нескольких корпусов (разные номера секций), а номера
    // у квартиры нет — корпус неизвестен, кнопки нет: показать «не тот дом» хуже, чем ничего.
    // ⛔ Ответ помнится на пару «секция + номер», а разбор ссылок корпусов делается один
    // раз: на странице студий Самолёта-6 квартир 5 тысяч, корпусов — десятки, и перебор
    // с URLSearchParams на каждую квартиру стоил главному потоку заметных долей секунды
    // (доводка r3, проверка Б P2-7).
    let corpusFilters = null;
    const corpusMemo = new Map();
    function corpusBySection(section, number) {
        if (!section) return '';
        const key = section + '\u0000' + (number || '');
        if (corpusMemo.has(key)) return corpusMemo.get(key);
        if (!corpusFilters) corpusFilters = Array.from(options, ([id, option]) => ({ id, ...corpusFilter(option) }));
        const found = [];
        corpusFilters.forEach(filter => {
            if (!filter.section.split('|').includes(section)) return;
            const numbers = filter.sectionNumbers.split('|').filter(Boolean);
            if (number ? (numbers.length === 0 || numbers.includes(number)) : true) found.push({ id: filter.id, numbers });
        });
        let result = '';
        if (found.length === 1) result = found[0].id;
        else if (number) {
            const exact = found.filter(item => item.numbers.includes(number));
            result = exact.length === 1 ? exact[0].id : '';
        }
        corpusMemo.set(key, result);
        return result;
    }

    // Одна кнопка-образец, дальше — копии: ни своих обработчиков, ни своей подсказки у
    // кнопки нет. Нажатие ловит ОДИН делегат на документе (ниже), подсказка — CSS по
    // data-hint (не нативный title): тёмная, с золотом.
    const SHOW_HINT = 'Покажем на генплане дом, где находится эта квартира';
    let showSample = null;
    function showButton(id) {
        if (!showSample) {
            showSample = document.createElement('button');
            showSample.type = 'button';
            showSample.className = 'jk-genplan-show';
            showSample.dataset.hint = SHOW_HINT;
            const icon = document.createElement('i');
            icon.className = 'fa-solid fa-map-location-dot';
            icon.setAttribute('aria-hidden', 'true');
            const text = document.createElement('span');
            text.textContent = 'На генплане';
            showSample.append(icon, text);
        }
        const button = showSample.cloneNode(true);
        button.dataset.genplanShow = id;
        button.setAttribute('aria-label', 'На генплане: ' + (options.get(id)?.dataset.label || 'корпус') + '. ' + SHOW_HINT);
        return button;
    }

    // Кнопки ставятся на квартиры списка: карточки витрины (их рисует js/flats.js,
    // корпус — в data-flat-section), сетку и лоты страницы комнатности. Список
    // перерисовывается — следим за контейнером и дополняем новые карточки.
    // ⛔ Квартиры ВНУТРИ ЗАКРЫТОЙ карточки планировки получают кнопку при её раскрытии
    // (`toggle` ниже), а не при загрузке: их не видно, а на студиях Самолёта-6 это
    // 5 тысяч кнопок и +0,4–1,1 с блокировки главного потока (проверка Б P2-7).
    let cardContainers = null;
    const decorated = new WeakSet();
    function containersOfCards() {
        if (!cardContainers) {
            try {
                cardContainers = root.dataset.genplanCards ? Array.from(document.querySelectorAll(root.dataset.genplanCards)) : [];
            } catch { cardContainers = []; }
        }
        return cardContainers;
    }
    function decorate(scope) {
        const containers = containersOfCards();
        (scope ? [scope] : containers).forEach(container => {
            container.querySelectorAll('[data-flat-section], [data-plan-lot][data-section]').forEach(item => {
                if (decorated.has(item)) return;
                const plan = item.hasAttribute('data-plan-lot') ? item.closest('details') : null;
                if (plan && !plan.open) return;
                decorated.add(item);
                if (item.querySelector('.jk-genplan-show')) return;
                const id = corpusBySection(item.dataset.flatSection || item.dataset.section || '',
                    item.dataset.flatSectionNumber || item.dataset.sectionNumber || '');
                if (!id) return;
                const slot = item.querySelector('[data-genplan-show-slot]') || item;
                slot.appendChild(showButton(id));
            });
        });
        return containers;
    }

    if (compact) {
        // Кнопки на странице (карточки списка и кнопка страницы квартиры) — один делегат.
        document.addEventListener('click', event => {
            const button = event.target.closest && event.target.closest('[data-genplan-show]');
            if (!button) return;
            const before = snapshotFrom(button);
            if (!locate(button.dataset.genplanShow)) return;
            showBack('Вернуться к квартире', button, null, before);
            scrollToLocated(locatedIds);
            // Кнопка внутри <summary> раскрыла бы карточку планировки — это не нужно.
            event.preventDefault();
            event.stopPropagation();
        }, true);

        // Вопросы соседних скриптов (25.09.2026): окно планировки (js/plan-modal.js) и
        // раскрытая панель квартир (js/jk-filter-results.js) спрашивают, какие корпуса
        // схемы у секций планировки, — событие синхронное, ответ в `detail.ids`. Корпус
        // не обведён или неоднозначен — его нет в ответе, кнопки у них нет.
        document.addEventListener('broni:genplan-find', event => {
            const detail = event.detail;
            if (!detail || !Array.isArray(detail.sections)) return;
            const ids = [];
            detail.sections.forEach(item => {
                const section = typeof item === 'string' ? item : String((item && item.section) || '');
                const number = item && typeof item === 'object' ? String(item.number || '') : '';
                const id = corpusBySection(section, number);
                if (id && !ids.includes(id)) ids.push(id);
            });
            detail.ids = ids;
        });
        // …и просят показать: подсветка, подпись, подъём к генплану, кнопка возврата.
        document.addEventListener('broni:genplan-locate', event => {
            const detail = event.detail || {};
            const before = snapshotFrom(detail.from || null);
            if (!locate(Array.isArray(detail.ids) ? detail.ids : [], String(detail.what || ''))) return;
            showBack(String(detail.back || ''), detail.from || null, detail.restore, before);
            scrollToLocated(locatedIds);
        });
    }

    select.addEventListener('change', () => {
        if (compact || clickBehavior !== 'section') pick(select.value, false);
        else choose(select.value);
    });
    if (resetAll) resetAll.addEventListener('click', () => pick('', false));
    // «Сбросить» фильтра витрины и сетки комнатности снимает и корпус — подсветка на
    // схеме и строка состояния уходят следом (js/flats.js, js/jk-rooms-plans.js).
    if (compact) document.addEventListener('broni:flats-filters-reset', () => {
        hideBack();
        clearLocated();
        filtered = null;
        choose('');
    });
    // Вверх по уровням: «Назад» — на один, звено пути — сразу на свой уровень. Фокус — на
    // область того уровня, из которой пришли.
    function goUp(targetId) {
        if (!scenes.has(targetId)) return;
        const previousId = root.dataset.genplanActiveScene;
        let child = previousId;
        for (let guard = 0; guard < 12 && child && child !== 'master'; guard++) {
            const parent = scenes.get(child)?.dataset.parentScene || 'master';
            if (parent === targetId) break;
            child = parent;
        }
        if (compact && clickBehavior === 'section' && select.value) announce('');
        choose('');
        showScene(targetId);
        const controls = Array.from(scenes.get(targetId)?.querySelectorAll('[data-genplan-group], [data-genplan-building]') || []);
        const previous = controls.find(control => control.dataset.genplanGroup === child) || controls[0];
        if (previous) {
            controls.forEach(control => control.setAttribute('tabindex', control === previous ? '0' : '-1'));
            previous.focus({ preventScroll: true });
        }
    }
    if (back) back.addEventListener('click', () => {
        goUp(scenes.get(root.dataset.genplanActiveScene)?.dataset.parentScene || 'master');
    });

    // Измеряем настоящий текст: кириллица и загруженный шрифт дают разную ширину.
    // Расстояния переводятся из пикселей в SVG viewBox.
    const labelLayouts = new Map();
    let labelFrame = 0;
    // SVG может получить окончательные метрики позже fonts.ready (например,
    // после появления секции на экране). Наблюдаем размер самих букв, а не
    // только контейнера: сдвиг x/y размер текста не меняет и петлю не создаёт.
    const labelSizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
        // Буквы изменили размер (догрузился шрифт) — прежние замеры подписей недействительны.
        labelLayouts.forEach(state => { state.measuredSize = 0; });
        if (labelFrame) return;
        labelFrame = requestAnimationFrame(() => {
            labelFrame = 0;
            labelLayouts.forEach((state, svg) => layoutLabels(svg));
        });
    }) : null;

    function labelsOverlap(a, b) {
        return a.x < b.x + b.width && a.x + a.width > b.x
            && a.y < b.y + b.height && a.y + a.height > b.y;
    }

    // Signed distance to the ring: positive only strictly inside this polygon.
    function labelDistance(x, y, points) {
        let inside = false;
        let squared = Infinity;
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
            const [ax, ay] = points[j];
            const [bx, by] = points[i];
            if ((ay > y) !== (by > y) && x < (bx - ax) * (y - ay) / (by - ay) + ax) inside = !inside;
            const dx = bx - ax;
            const dy = by - ay;
            const length = dx * dx + dy * dy;
            const t = length ? Math.max(0, Math.min(1, ((x - ax) * dx + (y - ay) * dy) / length)) : 0;
            squared = Math.min(squared, (x - ax - t * dx) ** 2 + (y - ay - t * dy) ** 2);
        }
        return (inside ? 1 : -1) * Math.sqrt(squared);
    }

    // Later foreign contours receive the hit in an overlap, just as SVG paint
    // order does. The clearance is positive only in the exposed part of this
    // building; it does not depend on hover/focus or the selected building.
    function labelVisibleDistance(x, y, points, occluders) {
        let distance = labelDistance(x, y, points);
        occluders.forEach(ring => { distance = Math.min(distance, -labelDistance(x, y, ring)); });
        return distance;
    }

    // Pole of inaccessibility, computed once per displayed polygon. A max heap
    // searches cells by their possible clearance; no dependency or DOM reads.
    // Invalid/degenerate rings get no label rather than an outside fallback.
    function labelPole(points, box, occluders) {
        if (points.length < 3 || points.some(point => point.some(value => !Number.isFinite(value)))) return null;
        const area = points.reduce((sum, point, i) => {
            const next = points[(i + 1) % points.length];
            return sum + point[0] * next[1] - next[0] * point[1];
        }, 0);
        if (!area || !box || !box.width || !box.height) return null;
        const cell = (x, y, half) => {
            const distance = labelVisibleDistance(x, y, points, occluders);
            return { x, y, half, distance, max: distance + half * Math.SQRT2 };
        };
        const queue = [];
        const push = item => {
            let index = queue.length;
            queue.push(item);
            while (index > 0) {
                const parent = (index - 1) >> 1;
                if (queue[parent].max >= item.max) break;
                queue[index] = queue[parent];
                index = parent;
            }
            queue[index] = item;
        };
        const pop = () => {
            const top = queue[0];
            const last = queue.pop();
            if (queue.length) {
                let index = 0;
                while (index * 2 + 1 < queue.length) {
                    let child = index * 2 + 1;
                    if (child + 1 < queue.length && queue[child + 1].max > queue[child].max) child++;
                    if (last.max >= queue[child].max) break;
                    queue[index] = queue[child];
                    index = child;
                }
                queue[index] = last;
            }
            return top;
        };
        let best = cell(box.x + box.width / 2, box.y + box.height / 2, 0);
        push(cell(best.x, best.y, Math.max(box.width, box.height) / 2));
        const precision = Math.min(1, Math.min(box.width, box.height) / 16);
        while (queue.length) {
            const current = pop();
            if (current.distance > best.distance) best = current;
            if (current.max - Math.max(0, best.distance) <= precision) continue;
            const half = current.half / 2;
            if (!half || current.x + half === current.x || current.y + half === current.y) continue;
            for (const dx of [-half, half]) {
                for (const dy of [-half, half]) push(cell(current.x + dx, current.y + dy, half));
            }
        }
        return best.distance > 0 ? { x: best.x, y: best.y, height: box.height } : null;
    }

    // ⛔ ШИРИНА СХЕМЫ И РАЗМЕРЫ ПОДПИСЕЙ — ИЗ ЗАМЕРА, СДЕЛАННОГО ОДИН РАЗ (P1-3). Раскладку
    // подписей зовут выбор корпуса и «Посмотреть на генплане»: каждый
    // вызов со свежим чтением геометрии после записей пересчитывал раскладку всей
    // страницы. Ширину обновляет drawLabels (показ схемы, поворот, смена размера окна),
    // размеры букв — перемеряются при смене кегля или догрузке шрифта.
    function layoutLabels(svg) {
        const state = labelLayouts.get(svg);
        const view = svg.viewBox.baseVal;
        const width = state ? state.width : 0;
        if (!state || !width || svg.hasAttribute('hidden')) return;
        const scale = width / view.width;
        const size = Math.max(12, Math.min(18, width / 52)) / scale;
        const padding = 4 / scale;
        const preferred = select.value;
        const placed = [];
        if (state.measuredSize !== size) {
            // Сначала все записи, затем чтение геометрии — один проход layout браузера.
            state.labels.forEach(label => {
                label.text.removeAttribute('hidden');
                label.text.setAttribute('font-size', String(size));
                label.text.setAttribute('x', '0');
                label.text.setAttribute('y', '0');
            });
            state.labels.forEach(label => {
                const b = label.text.getBBox();
                label.bounds = { x: b.x, y: b.y, width: b.width, height: b.height };
            });
            state.measuredSize = size;
        }
        const measured = state.labels.slice();
        measured.sort((a, b) => Number(b.id === preferred) - Number(a.id === preferred)
            || a.anchor.y - b.anchor.y || a.index - b.index);
        measured.forEach(label => {
            const { bounds, anchor, points, occluders, text, leader } = label;
            const centreX = anchor.x;
            const centreY = anchor.y;
            const rect = { x: 0, y: 0, width: bounds.width + padding * 2, height: bounds.height + padding * 2 };
            // Keep the anchor at the pole even when a long caption extends past
            // the canvas edge. Clamping its text box can move it off a thin ring.
            rect.x = centreX + bounds.x - padding;
            const naturalY = centreY + bounds.y - padding;
            const candidates = [Math.max(view.y, Math.min(naturalY, view.y + view.height - rect.height))];
            placed.forEach(other => {
                if (rect.x < other.x + other.width && rect.x + rect.width > other.x) {
                    candidates.push(other.y - rect.height, other.y + other.height);
                }
            });
            candidates.sort((a, b) => Math.abs(a - naturalY) - Math.abs(b - naturalY) || a - b);
            const reach = Math.max(size * 4, anchor.height / 2);
            const y = candidates.find(top => {
                rect.y = top;
                return rect.width <= view.width && top >= view.y
                    && top + rect.height <= view.y + view.height
                    && Math.abs(top - naturalY) <= reach
                    && labelVisibleDistance(rect.x + padding - bounds.x, top + padding - bounds.y, points, occluders) > 0
                    && labelVisibleDistance(rect.x + padding + bounds.width / 2, top + padding + bounds.height / 2, points, occluders) > 0
                    && !placed.some(other => labelsOverlap(rect, other));
            });
            const visible = y !== undefined;
            text.toggleAttribute('hidden', !visible);
            leader.setAttribute('hidden', '');
            text.setAttribute('x', String(centreX));
            text.setAttribute('y', String(centreY));
            if (!visible) return;
            rect.y = y;
            placed.push(rect);
            const x = rect.x + padding - bounds.x;
            const baseline = rect.y + padding - bounds.y;
            text.setAttribute('x', String(x));
            text.setAttribute('y', String(baseline));
            // Выноска сохраняет связь с корпусом после разнесения подписей.
            if (Math.hypot(x - centreX, baseline - centreY) > padding) {
                leader.setAttribute('x1', String(centreX));
                leader.setAttribute('y1', String(centreY));
                leader.setAttribute('x2', String(Math.max(rect.x + padding, Math.min(centreX, rect.x + rect.width - padding))));
                leader.setAttribute('y2', String(Math.max(rect.y + padding, Math.min(centreY, rect.y + rect.height - padding))));
                leader.removeAttribute('hidden');
            }
        });
    }

    // Без фиксированного лимита корпусов. Когда рядом нет места, подпись уступает
    // соседям, но получает приоритет после выбора корпуса. Наведение и фокус
    // не двигают подписи между первым движением указателя и нажатием.
    function drawLabels(scene) {
        const svg = scene.tagName.toLowerCase() === 'svg' ? scene : scene.querySelector('svg');
        const rect = svg ? svg.getBoundingClientRect() : null;
        const view = svg ? svg.viewBox.baseVal : null;
        // Потолок высоты оставляет поля внутри SVG. Подписи считаем по ширине
        // самого изображения, чтобы их экранный размер не уменьшался с ним.
        const width = rect && view && view.height > 0
            ? Math.min(rect.width, rect.height * view.width / view.height) : 0;
        if (!svg || !width) return;
        if (!labelLayouts.has(svg)) {
            // ⛔ СНАЧАЛА ВСЕ ЗАМЕРЫ КОНТУРОВ, ПОТОМ ВСЕ ВСТАВКИ (P1-3): чередование
            // «вставить подпись → замерить следующий контур» пересчитывало раскладку
            // страницы на каждом корпусе — 66 раз подряд на Самолёте-6.
            const shapes = Array.from(scene.querySelectorAll('[data-genplan-building]'));
            const rings = shapes.map(polygon => {
                const values = (polygon.getAttribute('points') || '').trim().split(/[\s,]+/).map(Number);
                return values.length % 2 ? [] : Array.from({ length: values.length / 2 }, (_, i) => values.slice(i * 2, i * 2 + 2));
            });
            const boxes = shapes.map(polygon => shapeBox(polygon));
            const occluders = shapes.map((polygon, index) => rings.filter((ring, other) => other > index
                && shapes[other].dataset.genplanBuilding !== polygon.dataset.genplanBuilding
                && ring.length >= 3 && ring.every(point => point.every(Number.isFinite))
                && boxes[index] && boxes[other] && labelsOverlap(boxes[index], boxes[other])));
            const anchors = shapes.map((polygon, index) => labelPole(rings[index], boxes[index], occluders[index]));
            const state = { labels: [], width, measuredSize: 0 };
            labelLayouts.set(svg, state);
            const namespace = 'http://www.w3.org/2000/svg';
            const lines = document.createElementNS(namespace, 'g');
            const texts = document.createElementNS(namespace, 'g');
            lines.setAttribute('aria-hidden', 'true');
            texts.setAttribute('aria-hidden', 'true');
            svg.appendChild(lines);
            svg.appendChild(texts);
            shapes.forEach((polygon, index) => {
                const caption = (polygon.querySelector('title')?.textContent || '').trim();
                if (!caption || !anchors[index]) return;
                const short = caption.replace(/^\s*(корпус|литер|дом|блок|секция|здание)\s*[№#]?\s*/i, '').trim() || caption;
                const text = document.createElementNS(namespace, 'text');
                text.setAttribute('class', 'jk-genplan-label');
                text.setAttribute('aria-hidden', 'true');
                text.dataset.genplanLabel = polygon.dataset.genplanBuilding;
                // Подпись пропускает нажатие к контуру под ней. Её якорь внутри
                // своего корпуса, а широкие буквы не забирают нажатия у соседа.
                // На метке только название; скидка остаётся в существующей подсказке.
                text.textContent = short;
                const leader = document.createElementNS(namespace, 'line');
                leader.setAttribute('class', 'jk-genplan-label-leader');
                lines.appendChild(leader);
                texts.appendChild(text);
                if (labelSizeObserver) labelSizeObserver.observe(text);
                state.labels.push({ text, leader, id: polygon.dataset.genplanBuilding, anchor: anchors[index], points: rings[index], occluders: occluders[index], index });
            });
            svg.dataset.labelled = 'true';
        }
        const state = labelLayouts.get(svg);
        if (state.width !== width) { state.width = width; state.measuredSize = 0; }
        layoutLabels(svg);
    }

    function activate(control, focusScene) {
        if (compact) interacted = true;
        if (control.dataset.genplanGroup) {
            if (compact && clickBehavior === 'section' && select.value) announce('');
            choose('');
            showScene(control.dataset.genplanGroup);
            if (focusScene) scenes.get(control.dataset.genplanGroup)?.querySelector('[tabindex="0"]')?.focus({ preventScroll: true });
        } else if (compact || clickBehavior !== 'section') {
            pick(control.dataset.genplanBuilding, true);
        } else {
            choose(control.dataset.genplanBuilding);
            goToFlats(control.dataset.genplanBuilding);
        }
    }

    // Клик по корпусу ведёт к его квартирам — слово владельца 22.09.2026: «при клике
    // на корпус он перекидывал наверх с квартирами в этом корпусе». Вкладку корпуса
    // в блоке квартир нажимаем ЕЁ ЖЕ обработчиком, своего фильтра не заводим: фильтр
    // общий для вкладок, ленты корпусов и генплана, и второй разошёлся бы с первым.
    function goToFlats(id) {
        const option = options.get(id);
        const section = option?.dataset.section;
        if (!section) return;
        const flats = document.getElementById('jkFlats');
        // ⛔ Перебором, а не селектором по атрибуту: имена секций содержат точки
        // и пробелы («поз.5», «Литер 8»), и подстановка их в селектор его ломает.
        const tabs = document.querySelectorAll('#jkCorpusTabs .jk-corpus-tab');
        const tab = Array.from(tabs).find(item => item.dataset.corpus === section);
        if (tab && flats) {
            tab.click();
            const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            flats.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
            return;
        }
        // Корпус выбирается в ТОМ ЖЕ фильтре квартир, что и руками, — слово
        // владельца 22.09.2026: «должен открывать те квартиры, которые есть выше
        // у нас в фильтре, а не переводить его на отдельную страницу». Выбор
        // ставится в поле и посылается 'change', чтобы сработал штатный
        // обработчик фильтра; своего пути к выдаче не заводим.
        const picker = document.getElementById('jkFilterSections');
        // В полном виде вкладки перечисляют одиночные секции. Дом со списком
        // передаём целиком штатному фильтру, как в его серверной ссылке.
        if (picker) picker.querySelectorAll('[data-genplan-sections]').forEach(item => item.remove());
        if (picker && section.includes('|') && corpusFilter(option).section === section) {
            const combined = document.createElement('option');
            combined.value = section;
            combined.textContent = option.dataset.label || section;
            combined.dataset.genplanSections = '';
            picker.appendChild(combined);
        }
        if (picker && Array.from(picker.options).some(item => item.value === section)) {
            picker.value = section;
            picker.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (flats) {
            const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            flats.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        }
    }

    scenes.forEach(scene => {
        const controls = Array.from(scene.querySelectorAll('[data-genplan-building], [data-genplan-group]'));
        // Chromium может «помочь» пальцу попасть в соседнюю большую SVG-кнопку,
        // даже когда исходная точка внутри своего узкого контура. Сохраняем
        // корпус сразу: совместимый click округляет координаты, а focus соседа
        // расширяет его обводку и меняет результат позднего hit-test.
        let touchHit = null;
        scene.addEventListener('pointerdown', event => {
            touchHit = event.pointerType === 'touch' ? {
                control: document.elementFromPoint(event.clientX, event.clientY)
                    ?.closest?.('[data-genplan-building], [data-genplan-group]'),
            } : null;
        }, { passive: true });
        scene.addEventListener('pointercancel', () => { touchHit = null; }, { passive: true });
        scene.addEventListener('click', event => {
            const hit = touchHit;
            touchHit = null;
            const control = hit && event.detail !== 0 ? hit.control
                : event.target?.closest?.('[data-genplan-building], [data-genplan-group]');
            if (controls.includes(control)) activate(control, false);
        });
        controls.forEach((control, index) => {
            control.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    activate(control, true);
                    return;
                }
                const directions = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
                let next = null;
                if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = controls.length - 1;
                else if (directions[event.key]) next = (index + directions[event.key] + controls.length) % controls.length;
                if (next === null) return;
                event.preventDefault();
                // Компактный вид: стрелки только ведут фокус. Выбор по стрелке сузил бы
                // список на каждом шаге, а Enter на уже выбранном корпусе снял бы отбор.
                if (controls[next].dataset.genplanBuilding && !compact) choose(controls[next].dataset.genplanBuilding);
                else controls.forEach((candidate, candidateIndex) => candidate.setAttribute('tabindex', candidateIndex === next ? '0' : '-1'));
                controls[next].focus();
            });
        });
        const image = scene.querySelector('[data-genplan-image]');
        if (image) image.addEventListener('error', () => {
            scene.dataset.failed = 'true';
            scene.setAttribute('hidden', '');
            if (root.dataset.genplanActiveScene === scene.dataset.genplanScene) showNotice(true);
        });
    });
    showScene('master');

    // Пересчёт при изменении реального размера схемы, включая поворот телефона.
    const refreshLabels = () => scenes.forEach(scene => {
        if (scene.hasAttribute('hidden')) return;
        // Ширина полосы изменилась (окно, поворот) — окно схемы режется заново.
        cropScene(scene);
        drawLabels(scene);
        // Схема стала шире (поворот телефона, масштаб браузера) — ширина картинки следом.
        loadScheme(scene, false);
        placeAreaList();
    });
    if (typeof ResizeObserver === 'function') {
        const sizes = new WeakMap();
        new ResizeObserver(entries => {
            if (entries.some(entry => {
                const width = entry.contentRect.width;
                if (sizes.get(entry.target) === width) return false;
                sizes.set(entry.target, width);
                return true;
            })) refreshLabels();
        }).observe(root);
    }
    // Высота окна меняет ограниченный генплан даже при прежней ширине root.
    window.addEventListener('resize', refreshLabels);
    if (document.fonts) document.fonts.ready.then(refreshLabels);

    // Плашка «Генплан комплекса · N корпусов — Показать / Скрыть» на телефоне. На карточке
    // ЖК, странице комнатности, витрине и странице квартиры схема ОТКРЫТА с первого кадра
    // (слово владельца 26.09.2026) — это состояние печатает сервер (`is-open`, «Скрыть»),
    // скрипт его только читает; без флага страницы плашка свёрнута и раскрывается по
    // нажатию. Размер схемы
    // меняется только по высоте, а наблюдатель выше ловит ширину — поэтому подписи
    // и картинку зовём сами, когда раскрытая схема получила размер.
    const compactToggle = compact ? root.querySelector('[data-genplan-toggle]') : null;
    function setOpen(open) {
        if (!compactToggle) return;
        root.classList.toggle('is-open', open);
        compactToggle.setAttribute('aria-expanded', String(open));
        const toggleLabel = compactToggle.querySelector('[data-genplan-toggle-label]');
        if (toggleLabel) toggleLabel.textContent = open ? 'Скрыть' : 'Показать';
        if (open) requestAnimationFrame(refreshLabels);
    }
    if (compactToggle) compactToggle.addEventListener('click', () => setOpen(!root.classList.contains('is-open')));

    // Кнопки «На генплане» — на уже отрисованные карточки и на каждую перерисовку списка.
    if (compact) {
        const containers = decorate();
        if (typeof MutationObserver === 'function' && containers.length) {
            let queued = 0;
            const observer = new MutationObserver(() => {
                if (queued) return;
                queued = requestAnimationFrame(() => {
                    queued = 0;
                    decorate();
                    // Свои же вставки кнопок наблюдателю не повод для второго обхода.
                    observer.takeRecords();
                });
            });
            containers.forEach(container => observer.observe(container, { childList: true, subtree: true }));
            // Раскрыли карточку планировки — кнопки её квартирам (событие не всплывает,
            // поэтому один слушатель на погружении, а не по слушателю на карточку).
            document.addEventListener('toggle', event => {
                const plan = event.target;
                if (plan && plan.open && plan.tagName === 'DETAILS' && containers.some(container => container.contains(plan))) decorate(plan);
            }, true);
        }
        // Страница квартиры: корпус этой квартиры подсвечен сразу (без прокрутки) —
        // долистав до генплана, человек видит свой дом и подпись.
        const own = root.dataset.genplanLocate;
        if (own && options.has(own)) {
            choose(own);
            locatedId = own;
            if (status) {
                status.hidden = false;
                status.textContent = (options.get(own).dataset.label || 'Корпус') + ' — здесь эта квартира';
            }
        }
        // Витрина: корпус из адреса — при загрузке и на каждый шаг «Назад» / «Вперёд».
        if (followsAddress && resultsTarget()) {
            if (corpusFromAddress()) syncFromAddress();
            window.addEventListener('popstate', syncFromAddress);
        }
        // Страница группы, открытая строкой комнатности с генплана соседней группы
        // (`#planirovki&sections=…`, 28.09.2026): тот же корпус выбирается и здесь — список
        // ниже сужается до его квартир, страница встаёт на планировки. Выбор — после
        // загрузки страницы: к этому моменту фильтр блока квартир (js/jk-filter.js) слушает
        // событие корпуса, а вёрстка над списком устоялась.
        if (!followsAddress && resultsTarget()) {
            const fromHash = corpusFromPlansHash();
            if (fromHash) {
                const run = () => pick(fromHash, false);
                if (document.readyState === 'complete') setTimeout(run, 0);
                else window.addEventListener('load', run, { once: true });
            }
        }
    }

    // Подсказка при наведении: квартиры, срок сдачи, цена — слово владельца
    // 22.09.2026. Числа берём из того же <option>, что и панель под схемой:
    // второго источника не заводим, иначе подсказка и панель разойдутся.
    (function corpusTip() {
        const tip = root.querySelector('[data-genplan-tip]');
        if (!tip) return;
        const parts = {
            name: tip.querySelector('[data-genplan-tip-name]'),
            count: tip.querySelector('[data-genplan-tip-count]'),
            source: tip.querySelector('[data-genplan-tip-source]'),
            deadline: tip.querySelector('[data-genplan-tip-deadline]'),
            floors: tip.querySelector('[data-genplan-tip-floors]'),
            price: tip.querySelector('[data-genplan-tip-price]'),
            discount: tip.querySelector('[data-genplan-tip-discount]'),
            rooms: tip.querySelector('[data-genplan-tip-rooms]'),
            link: tip.querySelector('[data-genplan-tip-link]'),
        };
        if (!parts.name || !parts.count || !parts.deadline || !parts.price) return;

        // Вне overflow карты и её transform-предков: fixed означает именно окно.
        document.body.appendChild(tip);
        let anchor = null;
        let hideTimer = 0;
        let showTimer = 0;
        const localUrl = url => typeof url === 'string' && /^\/(?![/\\])[^\s\\]*$/.test(url);
        const setText = (element, text) => {
            if (!element) return;
            element.textContent = text || '';
            element.hidden = !text;
        };

        const fill = id => {
            const option = options.get(id);
            if (!option) return false;
            parts.name.textContent = option.dataset.label || 'Корпус ' + option.dataset.name;
            setText(parts.count, option.dataset.countLabel);
            setText(parts.source, option.dataset.countLabel === 'Нет в нашей подборке' ? '' : option.dataset.countSource);
            setText(parts.deadline, window.BuildStatus.deadlineLine(option.dataset.deadline));
            setText(parts.floors, option.dataset.floorsLabel);
            setText(parts.price, option.dataset.priceLabel);
            setText(parts.discount, option.dataset.discountLabel);
            const hasFlats = localUrl(option.dataset.flatsUrl);
            if (parts.link) {
                parts.link.hidden = !hasFlats;
                if (hasFlats) parts.link.setAttribute('href', option.dataset.flatsUrl);
                else parts.link.removeAttribute('href');
                if (hasFlats && clickBehavior === 'all_flats') parts.link.textContent = 'Все квартиры ЖК →';
            }
            if (parts.rooms) {
                parts.rooms.replaceChildren();
                let rooms = [];
                try { rooms = JSON.parse(option.dataset.roomTypes || '[]'); } catch { /* Нет данных — нет строк. */ }
                if (hasFlats && Array.isArray(rooms)) rooms.forEach(room => {
                    if (!room || !localUrl(room.flats_url) || typeof room.label !== 'string'
                        || typeof room.area_label !== 'string' || typeof room.price_label !== 'string') return;
                    const row = document.createElement('a');
                    row.className = 'jk-genplan-tip__room';
                    row.dataset.rooms = String(room.rooms);
                    row.href = roomRowHref(room, option);
                    [[room.label, ''], [room.area_label, 'jk-genplan-tip__area'],
                        [room.price_label, 'jk-genplan-tip__room-price'], ['›', 'jk-genplan-tip__arrow']].forEach(([text, className]) => {
                        const span = document.createElement('span');
                        span.textContent = text;
                        if (className) span.className = className;
                        if (className === 'jk-genplan-tip__arrow') span.setAttribute('aria-hidden', 'true');
                        row.appendChild(span);
                    });
                    row.setAttribute('aria-label', room.label + ', ' + room.area_label + ', ' + room.price_label + ' — ' + parts.name.textContent);
                    parts.rooms.appendChild(row);
                });
                parts.rooms.hidden = !parts.rooms.childElementCount;
            }
            return true;
        };

        // Сначала ищем место сбоку от ВСЕГО контура, на узком окне — снизу/сверху.
        // Высота ограничивается свободным местом, поэтому карточка не накрывает дом.
        // Одна раскладка на обе подсказки — корпуса (tip) и области (groupTip ниже).
        const place = (el = tip, target = anchor) => {
            if (!target) return;
            const b = target.getBoundingClientRect();
            const viewport = window.visualViewport;
            // ⛔ Страница увеличена пальцами (слово владельца 27.09.2026: «окно с инфой о корпусе
            // становится сильно увеличенным, и не видно сути»): браузер растит и подсказку.
            // Уменьшаем её обратно на тот же множитель и ставим внутрь ВИДИМОЙ части экрана;
            // все отступы и размеры ниже — в координатах страницы, делённые на увеличение.
            const zoom = viewport && viewport.scale > 1.01 ? viewport.scale : 1;
            el.style.transformOrigin = '0 0';
            el.style.transform = zoom === 1 ? '' : 'scale(' + (1 / zoom).toFixed(4) + ')';
            const gap = 8 / zoom;
            const near = 12 / zoom;
            const left = (viewport?.offsetLeft || 0) + gap;
            const right = left + (viewport?.width || window.innerWidth) - 2 * gap;
            let top = (viewport?.offsetTop || 0) + gap;
            let bottom = top + (viewport?.height || window.innerHeight) - 2 * gap;
            document.querySelectorAll('.jk-sticky-nav, .jk-bottom-bar, .cookie-banner').forEach(panel => {
                const rect = panel.getBoundingClientRect();
                const style = window.getComputedStyle(panel);
                if (!rect.height || style.visibility === 'hidden' || style.opacity === '0' || panel.hidden) return;
                if (rect.top <= top && rect.bottom > top) top = rect.bottom + gap;
                else if (rect.bottom >= bottom && rect.top < bottom) bottom = rect.top - gap;
            });
            el.style.maxHeight = Math.max(0, (bottom - top) * zoom) + 'px';
            const w = el.offsetWidth / zoom;
            const h = el.offsetHeight / zoom;
            const clamp = (value, min, max) => Math.max(min, Math.min(value, Math.max(min, max)));
            let x;
            let y;
            if (b.right + near + w <= right || b.left - near - w >= left) {
                x = b.right + near + w <= right ? b.right + near : b.left - near - w;
                y = clamp(b.top + b.height / 2 - h / 2, top, bottom - h);
            } else {
                const below = Math.max(0, bottom - Math.max(top, b.bottom + near));
                const above = Math.max(0, Math.min(bottom, b.top - near) - top);
                const useBelow = below >= h || below >= above;
                el.style.maxHeight = (useBelow ? below : above) * zoom + 'px';
                x = clamp(b.left + b.width / 2 - w / 2, left, right - w);
                y = useBelow ? Math.max(top, b.bottom + near) : Math.min(bottom, b.top - near) - el.offsetHeight / zoom;
            }
            el.style.left = Math.round(x) + 'px';
            el.style.top = Math.round(y) + 'px';
        };

        const cancelHide = () => { clearTimeout(hideTimer); clearTimeout(showTimer); };
        const hide = () => {
            cancelHide();
            tip.hidden = true;
            polygons.forEach(polygon => polygon.classList.remove('has-tip'));
            anchor = null;
        };
        const later = () => {
            clearTimeout(hideTimer);
            hideTimer = setTimeout(() => {
                if (!tip.contains(document.activeElement)) hide();
            }, 350);
        };
        const show = polygon => {
            cancelHide();
            if (anchor === polygon && !tip.hidden) return;
            if (!fill(polygon.dataset.genplanBuilding)) return;
            hideGroupTip();
            anchor = polygon;
            polygons.forEach(item => item.classList.toggle('has-tip', item.dataset.genplanBuilding === polygon.dataset.genplanBuilding));
            tip.hidden = false;
            place();
        };

        polygons.forEach(polygon => {
            polygon.addEventListener('mouseenter', () => {
                cancelHide();
                if (anchor && anchor !== polygon) showTimer = setTimeout(() => show(polygon), 120);
                else show(polygon);
            });
            polygon.addEventListener('mouseleave', later);
            polygon.addEventListener('focus', () => show(polygon));
            polygon.addEventListener('blur', later);
            polygon.addEventListener('keydown', event => {
                if (event.key !== 'Tab' || event.shiftKey || tip.hidden) return;
                const first = tip.querySelector('a[href]');
                if (first) { event.preventDefault(); first.focus({ preventScroll: true }); }
            });
        });
        // Компактный вид: «Выбрать квартиру» в подсказке сужает список на этой же
        // странице, а не уводит на витрину корпуса — человек уже на странице квартир.
        if (compact && parts.link) parts.link.addEventListener('click', event => {
            // Страница квартиры: списка нет — ссылка ведёт на витрину корпуса, как обычно.
            if (!anchor || !resultsTarget()) return;
            event.preventDefault();
            const id = anchor.dataset.genplanBuilding;
            hide();
            pick(id, false);
        });
        // Строка «1-комнатные · от … ₽» в подсказке — слово владельца 25.09.2026: «если
        // клик на 1-комнатных — значит он должен просто ниже переместить на все
        // 1-комнатные, которые есть в том корпусе». На витрине отбор корпуса и
        // комнатности идёт на месте. На странице комнатности своя группа — тоже на месте
        // (страница уже про неё); чужая группа — обычный переход по ссылке на витрину.
        // 28.09.2026: чужая группа на странице группы — её страница с этим корпусом и якорем
        // планировок (roomRowHref), а не витрина; разбор — у roomRowInPlace().
        if (compact && parts.rooms) parts.rooms.addEventListener('click', event => {
            const row = event.target.closest('.jk-genplan-tip__room');
            if (!row || !anchor) return;
            const id = anchor.dataset.genplanBuilding;
            if (roomRowInPlace(event, row, id)) hide();
        });
        tip.addEventListener('mouseenter', cancelHide);
        tip.addEventListener('mouseleave', later);
        tip.addEventListener('focusin', cancelHide);
        tip.addEventListener('focusout', later);
        tip.addEventListener('keydown', event => {
            if (event.key === 'Tab' && event.shiftKey && document.activeElement === tip.querySelector('a[href]')) {
                event.preventDefault();
                anchor?.focus({ preventScroll: true });
            }
        });
        document.addEventListener('keydown', event => {
            if (event.key !== 'Escape' || tip.hidden) return;
            if (tip.contains(document.activeElement)) anchor?.focus({ preventScroll: true });
            hide();
        });
        document.addEventListener('pointerdown', event => {
            if (!tip.contains(event.target) && !event.target.closest('[data-genplan-building]')) hide();
        });
        // Прокрутка страницы/карты закрывает старое положение. Внутри карточки
        // список можно листать, когда высоты окна не хватает.
        document.addEventListener('scroll', event => {
            if (!tip.contains(event.target)) hide();
        }, true);
        window.addEventListener('resize', hide);
        // Пальцы меняют увеличение или сдвигают видимую часть — старое место и размер неверны.
        window.visualViewport?.addEventListener('resize', hide);
        window.visualViewport?.addEventListener('scroll', hide);
        select.addEventListener('change', hide);

        // ── Подсказка БОЛЬШОЙ ОБЛАСТИ (слово владельца 27.09.2026: «наведение на большую
        // область ничего не показывает»). Название области и список корпусов внутри неё
        // (вложенные области тоже): срок сдачи, квартиры в продаже, комнатности, цена от.
        // Числа — из тех же <option>, что у подсказки корпуса: второго источника нет.
        // ⛔ УЗЕЛ И ТЕКСТ ПОЯВЛЯЮТСЯ ТОЛЬКО В МОМЕНТ ПОКАЗА и стираются при скрытии: робот
        // Яндекса исполняет наш JS и берёт видимый текст в сниппет (1 456 страниц однажды).
        // На телефоне наведения нет: касание области, как и прежде, открывает приближение.
        const groupControls = Array.from(root.querySelectorAll('[data-genplan-group]'));
        if (!groupControls.length) return;
        const hoverable = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
        let groupTip = null;
        let groupAnchor = null;
        let groupTimer = 0;
        // Сцена области и все вложенные в неё сцены.
        const sceneTree = id => {
            const ids = new Set([id]);
            let grew = true;
            while (grew) {
                grew = false;
                scenes.forEach((scene, sceneId) => {
                    if (!ids.has(sceneId) && ids.has(scene.dataset.parentScene || '')) { ids.add(sceneId); grew = true; }
                });
            }
            return ids;
        };
        const fillGroup = control => {
            const inside = sceneTree(control.dataset.genplanGroup);
            const list = document.createElement('ul');
            list.className = 'jk-genplan-tip__corps';
            // Корпуса с квартирами в продаже — первыми; пустые (0 / «нет в подборке») ниже,
            // а если их больше трёх — одной строкой «ещё N без квартир в продаже»
            // (проверка 27.09: на Прокшино 50 пустых строк из 51 прятали единственный живой корпус).
            const sale = [];
            const rest = [];
            options.forEach((option, id) => {
                if (!inside.has(option.dataset.sceneId || 'master')) return;
                const hasFlats = localUrl(option.dataset.flatsUrl);
                const row = document.createElement(hasFlats ? 'a' : 'div');
                row.className = 'jk-genplan-tip__corp';
                row.dataset.genplanTipCorp = id;
                if (hasFlats) row.href = option.dataset.flatsUrl;
                fillCorpRow(row, option, 'jk-genplan-tip__corp');
                const item = document.createElement('li');
                item.appendChild(row);
                (parseInt(option.dataset.countLabel || '', 10) > 0 ? sale : rest).push(item);
            });
            const n = sale.length + rest.length;
            if (!n) return false;
            sale.forEach(item => list.appendChild(item));
            if (sale.length && rest.length > 3) {
                const more = document.createElement('li');
                addSpan(more, 'jk-genplan-tip__corp-more', 'Ещё ' + rest.length + ' ' + corpsWord(rest.length) + ' без квартир в продаже');
                list.appendChild(more);
            } else {
                rest.forEach(item => list.appendChild(item));
            }
            const title = document.createElement('p');
            title.className = 'jk-genplan-tip__name';
            title.textContent = scenes.get(control.dataset.genplanGroup)?.dataset.sceneName
                || (control.querySelector('title')?.textContent || '').trim() || 'Часть комплекса';
            const total = document.createElement('p');
            total.className = 'jk-genplan-tip__row';
            total.textContent = n + ' ' + corpsWord(n) + (sale.length && rest.length ? ', в продаже ' + sale.length : '');
            // «Показать на генплане» — то же, что нажатие на область: её приближенная сцена
            // со списком корпусов рядом (слово владельца 27.09.2026).
            const showArea = document.createElement('button');
            showArea.type = 'button';
            showArea.className = 'jk-genplan-tip__show';
            showArea.dataset.genplanTipShow = control.dataset.genplanGroup;
            const icon = document.createElement('i');
            icon.className = 'fa-solid fa-magnifying-glass-plus';
            icon.setAttribute('aria-hidden', 'true');
            addSpan(showArea, '', 'Показать на генплане');
            showArea.prepend(icon);
            groupTip.setAttribute('aria-label', title.textContent);
            groupTip.replaceChildren(title, total, showArea, list);
            return true;
        };
        const hideGroup = () => {
            clearTimeout(groupTimer);
            groupAnchor = null;
            if (!groupTip) return;
            groupTip.hidden = true;
            groupTip.replaceChildren();
        };
        hideGroupTip = hideGroup;
        const laterGroup = () => {
            clearTimeout(groupTimer);
            groupTimer = setTimeout(() => {
                if (!groupTip || !groupTip.contains(document.activeElement)) hideGroup();
            }, 350);
        };
        const createGroupTip = () => {
            groupTip = document.createElement('div');
            groupTip.className = 'jk-genplan-tip jk-genplan-tip--group';
            groupTip.setAttribute('role', 'group');
            groupTip.hidden = true;
            document.body.appendChild(groupTip);
            groupTip.addEventListener('mouseenter', () => clearTimeout(groupTimer));
            groupTip.addEventListener('mouseleave', laterGroup);
            groupTip.addEventListener('focusin', () => clearTimeout(groupTimer));
            groupTip.addEventListener('focusout', laterGroup);
            groupTip.addEventListener('keydown', event => {
                if (event.key === 'Tab' && event.shiftKey && document.activeElement === groupTip.querySelector('button, a[href]')) {
                    event.preventDefault();
                    groupAnchor?.focus({ preventScroll: true });
                }
            });
            groupTip.addEventListener('click', event => {
                const button = event.target.closest('[data-genplan-tip-show]');
                if (!button) return;
                const control = groupControls.find(item => item.dataset.genplanGroup === button.dataset.genplanTipShow);
                hideGroup();
                // С клавиатуры (detail 0) фокус уходит в сцену, мышью — остаётся на месте.
                if (control) activate(control, event.detail === 0);
            });
            // Строка корпуса ведёт туда же, куда ссылка его собственной подсказки: на
            // странице со списком — отбор на месте (схема сама приблизит его область),
            // иначе — обычный переход на квартиры корпуса.
            if (compact) groupTip.addEventListener('click', event => {
                const row = event.target.closest('a.jk-genplan-tip__corp');
                if (!row || !resultsTarget()) return;
                event.preventDefault();
                const id = row.dataset.genplanTipCorp;
                hideGroup();
                pick(id, false);
            });
        };
        const showGroup = control => {
            clearTimeout(groupTimer);
            if (groupAnchor === control && groupTip && !groupTip.hidden) return;
            hide();
            if (!groupTip) createGroupTip();
            if (!fillGroup(control)) { hideGroup(); return; }
            groupAnchor = control;
            groupTip.hidden = false;
            place(groupTip, control);
        };
        const keyboardFocus = control => {
            try { return control.matches(':focus-visible'); } catch { return true; }
        };
        groupControls.forEach(control => {
            control.addEventListener('mouseenter', () => { if (!hoverable || hoverable.matches) showGroup(control); });
            control.addEventListener('mouseleave', laterGroup);
            control.addEventListener('focus', () => { if (keyboardFocus(control)) showGroup(control); });
            control.addEventListener('blur', laterGroup);
            control.addEventListener('click', hideGroup);
            control.addEventListener('keydown', event => {
                if (event.key !== 'Tab' || event.shiftKey || !groupTip || groupTip.hidden) return;
                const first = groupTip.querySelector('button, a[href]');
                if (first) { event.preventDefault(); first.focus({ preventScroll: true }); }
            });
        });
        document.addEventListener('keydown', event => {
            if (event.key !== 'Escape' || !groupTip || groupTip.hidden) return;
            if (groupTip.contains(document.activeElement)) groupAnchor?.focus({ preventScroll: true });
            hideGroup();
        });
        document.addEventListener('pointerdown', event => {
            if (groupTip && !groupTip.contains(event.target) && !event.target.closest('[data-genplan-group]')) hideGroup();
        });
        document.addEventListener('scroll', event => {
            if (!groupTip || !groupTip.contains(event.target)) hideGroup();
        }, true);
        window.addEventListener('resize', hideGroup);
        window.visualViewport?.addEventListener('resize', hideGroup);
        window.visualViewport?.addEventListener('scroll', hideGroup);
    })();
})();
